var akimboApp = angular.module('akimboApp', [
  'ui.router',
  'ui.router.metatags',
  'ngIdle',
  'ngPostMessage',
  'ab-base64',
  'ng.shims.placeholder',
  'angularFileUpload',
  'ngMask',
  'LocalStorageModule',
  'akimboApp.controllers',
  'akimboApp.services',
  'akimboApp.constants',
  'akimboApp.brandData',
  'akimboApp.cardData',
  'akimboApp.config',
  'akimboApp.directives',
  'akimboApp.filters',
  'ngclipboard',
  'daterangepicker',
  'tandibar/ng-rollbar',
  'ngSanitize',
  'angular-md5',
  'countryCodes',
]);

akimboApp.config(['$stateProvider', '$httpProvider', '$urlRouterProvider', '$locationProvider', '$idleProvider', 'localStorageServiceProvider',
  'OVERLAY', 'SECURITY_QUESTIONS', 'STATES', 'EV_STEP1', 'EV_STEP2', 'EV_STEP3', 'DEFAULT_BRAND',
  function ($stateProvider, $httpProvider, $urlRouterProvider, $locationProvider, $idleProvider, localStorageServiceProvider,
            OVERLAY, SECURITY_QUESTIONS, STATES, EV_STEP1, EV_STEP2, EV_STEP3, DEFAULT_BRAND) {


    localStorageServiceProvider
        .setStorageCookie(0, '/')
        .setStorageType('sessionStorage')
        .setPrefix('akimboWeb')
        .setNotify(true, true);


    maxmind_user_id = "140151";
    (function() {
      var loadDeviceJs = function() {
        var element = document.createElement('script');
        element.src = 'https://device.maxmind.com/js/device.js';
        document.body.appendChild(element);
      };
      if (window.addEventListener) {
        window.addEventListener('load', loadDeviceJs, false);
      } else if (window.attachEvent) {
        window.attachEvent('onload', loadDeviceJs);
      }
    })();

    // Remove the hashtag from url's
    // $locationProvider.html5Mode(true);

    // Overwrite angular update to revert '#!' hashPrefix back to `#` https://docs.angularjs.org/guide/migration#commit-aa077e8
    $locationProvider.hashPrefix('');

    // Add httpInterceptor service to each request
    $httpProvider.interceptors.push('httpInterceptor');

    // Set inactivity durations in seconds
    $idleProvider.idleDuration(900);
    $idleProvider.warningDuration(15);

    // Abstract state to dynamically define the brand
    // All the other states in the app are children of this one
    $stateProvider.state('root', {
      url: '/:brand',
      abstract: true,
      params: {
        brand: {
          value: DEFAULT_BRAND,
          squash: true
        }
      },
      data: {roles: ['public', 'full']},
      views: {
        'top-header': {
          templateUrl: 'app/views/index/top-header.html'
        },
        'footer': {
          templateUrl: 'app/views/member/shared/footer.html'
        }
      }
    });

    // Member routes
    $stateProvider
        .state('member', {
          url: '/member/',
          data: {roles: ['authenticated', 'full'], overlay: false},
          params: {
            username: 'home',
          },
          abstract: true,
          views: {
            'top-header':{
              templateUrl: 'app/views/index/top-header.html',
              controller: function($scope, $rootScope, Session){
                $scope.isDashboard = true;
                $scope.username = Session.getUsername();
                $rootScope.$watch('firstName', function(){
                  $scope.firstName = $rootScope.firstName;
                });

              $scope.hideAccountAttribute = function(){
                //hide the account balance if the account isn't verified yet
              if(Session.getEnrollmentErrorCode() === 150){
                return true;
              }
              return false;
            };
              }
            },
            'main-header': {
              templateUrl: 'app/views/member/shared/main-header.html',
              controller: 'headerCtrl'
            },
            'virtualCard': {
              templateUrl: 'app/views/member/shared/virtual-card.html',
              controller: 'viewVirtualCardCtrl'
            },
            'virtualCardExpanded': {
              templateUrl: 'app/views/member/shared/virtual-card-expanded.html',
              controller: 'viewVirtualCardCtrl'
            },
            'container': {
              templateUrl: 'app/views/member/shared/feed-container.html',
              controller: 'accountHeaderCtrl'
            },
            'feed': {
              templateUrl: 'app/views/member/shared/feed.html',
              controller: 'accountHeaderCtrl'
            },
            'footer': {
              templateUrl: 'app/views/member/shared/footer.html'
            },
            'widgets': {
              templateUrl: 'app/views/member/shared/widgets.html',
              controller: 'widgetCtrl'
            },
            'inActive': {
              templateUrl: 'app/views/member/shared/in-active.html',
              controller: 'inActiveCtrl'
            }
          }
        })
        .state('member.home', {
          url: '{username}/',
          params: {
            username: 'home'
          },
          data: {roles: ['authenticated', 'full'], overlay: false},
          views: {
            'feed@member': {
              templateUrl: 'app/views/member/home/feed.html',
              controller: 'feedCtrl'
            },
            'virtualCard@': {
              templateUrl: 'app/views/member/shared/virtual-card.html',
              controller: 'viewVirtualCardCtrl'
            },
            'widgets@': {
              templateUrl: 'app/views/member/shared/widgets.html',
              controller: 'widgetCtrl'
            },
            'cardContainer@': {
              templateUrl: 'app/views/member/shared/double-wide-widgets.html',
              controller: 'cardContainerCtrl'
            }
          }
        })
        .state('member.home.expanded', {
          url: 'feed/expanded',
          data: {roles: ['authenticated', 'full'], overlay: false},
          views: {
            '@': {
              templateUrl: 'app/views/member/expanded/feed.html',
              controller: 'expandedCtrl'
            },
            'container@': {
              template: ''
            },
            'widgets@': {
              template: ''
            }
          }
        })
        .state('printFeed', {
          url: '/feed/print?Section&FromDate&ToDate&Count&Username',
          data: {roles: ['authenticated', 'full'], overlay: false},
          views: {
            'print-view': {
              templateUrl: 'app/views/member/expanded/print.html',
              controller: 'printFeedCtrl'
            }
          }
        })
        .state('printDirectDeposit', {
          url: '/feed/Bank&Routing&AccountNumber',
          data: {roles: ['authenticated', 'full'], overlay: false},
          views: {
            'print-view': {
              templateUrl: 'app/views/member/directdeposit/print.html',
              controller: 'printDirectDepositCtrl'
            }
          }
        })
        .state('viewAllCards', {
          url: '/viewAllCards',
          data: {roles: ['authenticated', 'full'], overlay: false},
          views: {
            'viewAllCards-view@': {
              templateUrl: 'app/views/member/shared/viewAllCards.html',
              controller: 'viewAllCardsCtrl'
            }
          }
        })
        // Transaction Overlay
        .state('member.home.transaction', {
          url: 'transaction/detail/{id}',
          params: {id: null},
          data: {roles: ['authenticated', 'full'], overlay: true},
          abstract: true,
          views: {
            'overlay@': {
              templateUrl: 'app/views/member/shared/overlay/layout.html',
              controller: 'transactionCtrl'
            }
          }
        })
        .state('member.home.transaction.detail', {
          url: '',
          data: {roles: ['authenticated', 'full'], overlay: true},
          views: {
            'header@member.home.transaction': {
              templateUrl: 'app/views/member/shared/overlay/header-default.html',
              controller: function ($scope){
                $scope.title = 'Additional information';
                $scope.info = 'Here you\'ll find more information on your transactions.';
              }
            },
            'step@member.home.transaction': {
              templateUrl: 'app/views/member/transaction/detail.html'
            },
            'footer@member.home.transaction': {
              templateUrl: 'app/views/member/shared/overlay/footer.html',
              controller: function($scope){
                $scope.mainBtn = {};
                $scope.close = true;
              }
            },
            'side@member.home.transaction': {
              templateUrl: 'app/views/member/shared/overlay/side-options.html'
            }
          }
        })


        // Send gift routes
        .state('member.home.send/gift', {
          url: 'send/gift',
          data: {roles: ['authenticated', 'full'], overlay: true},
          abstract: true,
          views: {
            'overlay@': {
              templateUrl: 'app/views/giftCard/widget-layout.html',
              controller: 'giftCardCtrl'
            }
          }
        })
        .state('member.home.send/gift.step1', {
          url: '',
          data: {roles: ['authenticated', 'full'], overlay: true},
          views: {
            'header@member.home.send/gift': {
              templateUrl: 'app/views/giftCard/widget-header.html',
              controller: function ($scope){
                $scope.title = 'Who Are You Sending A Gift To?';
                $scope.info = 'Send a gift card to friends and family. They will receive your gift in a text message or email and will be able to make purchases immediately online or add to Apple Wallet or Android Pay and make purchases in stores.';
              }
            },
            'step@member.home.send/gift': {
              templateUrl: 'app/views/giftCard/step1.html'
            },
            'side@member.home.send/gift': {
              template: ''
            },
            'footer@member.home.send/gift': {
              templateUrl: 'app/views/member/shared/overlay/footer.html',
              controller: function($scope){
                $scope.mainBtn = {
                  next: 'member.home.send/gift.step2',
                  attemptSubmission: true,
                  title: 'NEXT'
                };
                $scope.cancel = true;
              }
            }
          }
        })
        .state('member.home.send/gift.step2', {
          url: '',
          data: {roles: ['authenticated', 'full'], overlay: true},
          views: {
            'header@member.home.send/gift': {
              templateUrl: 'app/views/giftCard/widget-header.html',
              controller: function ($scope){
                $scope.title = 'Ok, select how you would like to send your Gift';
                $scope.info = 'Please select "By email" or "By mail"';
              }
            },
            'step@member.home.send/gift': {
              templateUrl: 'app/views/giftCard/step2.html'
            },
            'footer@member.home.send/gift': {
              templateUrl: 'app/views/member/shared/overlay/footer.html',
              controller: function($scope){
                $scope.mainBtn = {
                  attemptSubmission: true,
                  title: 'Next',
                  next: 'member.home.send/gift.step3'
                };
                $scope.cancel = true;
              }
            }
          }
        })
        .state('member.home.send/gift.step3', {
          url: '',
          data: {roles: ['authenticated', 'full'], overlay: true},
          views: {
            'header@member.home.send/gift': {
              templateUrl: 'app/views/giftCard/widget-header.html',
              controller: function ($scope){
                $scope.title = 'How would you like to pay for the gift?';
                $scope.info = 'Select the payment options below';
              }
            },
            'step@member.home.send/gift': {
              templateUrl: 'app/views/giftCard/step3.html'
            },
            'footer@member.home.send/gift': {
              templateUrl: 'app/views/member/shared/overlay/footer.html',
              controller: function($scope){
                $scope.mainBtn = {
                  processGiftForm: true,
                  title: 'PLACE ORDER',
                  next: 'member.home.send/gift.step3'
                };
                $scope.cancel = true;
              }
            }
          }
        })
        .state('member.home.send/gift.success', {
          url: '',
          data: {roles: ['authenticated', 'full'], overlay: true},
          views: {
            'header@member.home.send/gift': {
              templateUrl: 'app/views/giftCard/widget-header.html',
              controller: function ($scope){
                $scope.title = 'Success!';
                $scope.info = 'You\'ve Ordered a ' + $scope.brand.fullGiftProgramName;
              }
            },
            'step@member.home.send/gift': {
              templateUrl: 'app/views/giftCard/success.html'
            },
            'footer@member.home.send/gift': {
              templateUrl: 'app/views/member/shared/overlay/footer.html',
              controller: function($scope){
                $scope.close = true;
              }
            }
          }
        })


        // Send Routes
        .state('member.home.send/transfer', {
          url: 'send/transfer',
          data: {roles: ['authenticated', 'full'], overlay: true},
          abstract: true,
          params: {
            username: '',
            amount: '',
            firstName: '',
            lastName: '',
            transId: '',
          },
          views: {
            'overlay@': {
              templateUrl: 'app/views/member/shared/overlay/layout.html',
              controller: 'sendFundsCtrl'
            }
          }
        })
        .state('member.home.send/transfer.step1', {
          url: '',
          data: {roles: ['authenticated', 'full'], overlay: true},
          views: {
            'header@member.home.send/transfer': {
              templateUrl: 'app/views/member/shared/overlay/header-search.html',
              controller: function ($scope){
                $scope.title = 'Who Are You Sending Money To?';
                $scope.info = 'Start by searching for them in the box below. Send money to another ' + $scope.brand.programName + ' cardholder.';
              }
            },
            'step@member.home.send/transfer': {
              templateUrl: 'app/views/member/send/transfer/step1.html'
            },
            'side@member.home.send/transfer': {
              templateUrl: 'app/views/member/shared/overlay/side-options.html',
              controller: function ($scope){
                $scope.showSub = true;
                $scope.showAutoSends = true;
              }
            },
            'footer@member.home.send/transfer': {
              template: ''
            }
          }
        })
        .state('member.home.send/transfer.step2', {
          url: '',
          data: {roles: ['authenticated', 'full'], overlay: true},
          views: {
            'header@member.home.send/transfer': {
              templateUrl: 'app/views/member/shared/overlay/header-content.html',
              controller: function ($scope){
                $scope.title = 'Great, you\'re ready to move on';
                $scope.info = 'Simply enter the amount you wish to send, and then click Next.';
              }
            },
            'step@member.home.send/transfer': {
              templateUrl: 'app/views/member/send/transfer/step2.html'
            },
            'side@member.home.send/transfer': {
              templateUrl: 'app/views/member/shared/overlay/side-options.html',
              controller: function ($scope){
                $scope.showAddMessage = true;
                $scope.showAutoSends = true;

                $scope.addMessage = function(message){
                  $scope.formData.Note = message;
                  $scope.showAddMessageOption = false;
                };
              }
            },
            'footer@member.home.send/transfer': {
              templateUrl: 'app/views/member/shared/overlay/footer.html',
              controller: function($scope){
                $scope.mainBtn = {
                  attemptSubmission: true,
                  title: 'NEXT'
                };
                $scope.cancel = true;
              }
            }
          }
        })
        .state('member.home.send/transfer.step3', {
          url: '',
          data: {roles: ['authenticated', 'full'], overlay: true},
          views: {
            'header@member.home.send/transfer': {
              templateUrl: 'app/views/member/shared/overlay/header-content.html',
              controller: function ($scope){
                $scope.title = 'Ok, we\'re ready to send';
                $scope.info = 'Review your transfer below and click send when you\'re ready';
              }
            },
            'step@member.home.send/transfer': {
              templateUrl: 'app/views/member/send/transfer/step3.html'
            },
            'footer@member.home.send/transfer': {
              templateUrl: 'app/views/member/shared/overlay/footer.html',
              controller: function ($scope){
                $scope.mainBtn = {
                  processForm: true,
                  title: 'SEND'
                };
                $scope.btns = [{
                  title: 'EDIT',
                  state: 'member.home.send/transfer.step2'
                }];
                $scope.cancel = true;
              }
            }
          }
        })
        .state('member.home.send/transfer.step4', {
          url: '',
          data: {roles: ['authenticated', 'full'], overlay: true},
          views: {
            'header@member.home.send/transfer': {
              templateUrl: 'app/views/member/shared/overlay/header-content.html'
            },
            'step@member.home.send/transfer': {
              templateUrl: 'app/views/member/send/transfer/step4.html'
            },
            'footer@member.home.send/transfer': {
              templateUrl: 'app/views/member/shared/overlay/footer.html',
              controller: function ($scope){
                $scope.close = true;
              }
            }
          }
        })


        // Send Recurring
        .state('member.home.send/recurring', {
          url: 'send/recurring',
          data: {roles: ['authenticated', 'full'], overlay: true},
          abstract: true,
          views: {
            'overlay@': {
              templateUrl: 'app/views/member/shared/overlay/layout.html',
              controller: 'autoSendFundsCtrl'
            }
          }
        })
        .state('member.home.send/recurring.step1', {
          url: '',
          data: {roles: ['authenticated', 'full'], overlay: true},
          views: {
            'header@member.home.send/recurring': {
              templateUrl: 'app/views/member/shared/overlay/header-search.html',
              controller: function ($scope){
                $scope.title = 'Who Are You Sending Money To?';
                $scope.info = 'Start by searching for them in the box below. Send money to another ' + $scope.brand.programName + ' cardholder.';
              }
            },
            'step@member.home.send/recurring': {
              templateUrl: 'app/views/member/send/transfer/step1.html'
            },
            'side@member.home.send/recurring': {
              templateUrl: 'app/views/member/shared/overlay/side-options.html',
              controller: function ($scope){
                $scope.showSub = true;
                $scope.showManageAutoTransfers = true;
              }
            },
            'footer@member.home.send/recurring': {
              template: ''
            }
          }
        })
        .state('member.home.send/recurring.step2', {
          url: '',
          data: {roles: ['authenticated', 'full'], overlay: true},
          views: {
            'header@member.home.send/recurring': {
              templateUrl: 'app/views/member/shared/overlay/header-content.html',
              controller: function ($scope){
                $scope.title = 'Now this is convenient';
                $scope.info = 'Set up a monthly budget, allowance for the kids or help out a family member. It\'s easy to do good with your ' + $scope.brand.programName + ' card. Simply, enter an amount, a source and then select how often you would like to send money.';
              }
            },
            'step@member.home.send/recurring': {
              templateUrl: 'app/views/member/send/recurring/step2.html',
              resolve: {
                data: function(Session){
                  return Session.getBalance();
                }
              },
              controller: function($scope, data){
                $scope.balance = data;
              }
            },
            'footer@member.home.send/recurring': {
              templateUrl: 'app/views/member/shared/overlay/footer.html',
              controller: function($scope){
                $scope.mainBtn = {
                  attemptSubmission: true,
                  title: 'NEXT'
                };
                $scope.btns = [{
                  title: 'EDIT',
                  state: 'member.home.send/recurring.step1'
                }];
                $scope.cancel = true;
              }
            }
          }
        })
        .state('member.home.send/recurring.step3', {
          url: '',
          data: {roles: ['authenticated', 'full'], overlay: true},
          views: {
            'header@member.home.send/recurring': {
              templateUrl: 'app/views/member/shared/overlay/header-content.html',
              controller: function ($scope){
                $scope.title = 'Ok, let\s review';
                $scope.info = 'Look over the details below, and press save when you\'re ready';
              }
            },
            'step@member.home.send/recurring': {
              templateUrl: 'app/views/member/send/recurring/step3.html'
            },
            'footer@member.home.send/recurring': {
              templateUrl: 'app/views/member/shared/overlay/footer.html',
              controller: function ($scope){
                $scope.mainBtn = {
                  processForm: true,
                  title: 'SAVE'
                };
                $scope.btns = [{
                  title: 'EDIT',
                  state: 'member.home.send/recurring.step2'
                }];
                $scope.cancel = true;
              }
            }
          }
        })
        .state('member.home.send/recurring.step4', {
          url: '',
          data: {roles: ['authenticated', 'full'], overlay: true},
          views: {
            'header@member.home.send/recurring': {
              templateUrl: 'app/views/member/shared/overlay/header-content.html',
              controller: function ($scope){
                var startDate = moment($scope.$parent.formData.StartDate).format('dddd, MMMM DD YYYY');
                $scope.title = 'Your auto send is set up!';
                $scope.info = 'Your auto sends will begin on ' + startDate + '.';
              }
            },
            'step@member.home.send/recurring': {
              templateUrl: 'app/views/member/send/recurring/step3.html'
            },
            'footer@member.home.send/recurring': {
              templateUrl: 'app/views/member/shared/overlay/footer.html',
              controller: function ($scope){
                $scope.close = true;
              }
            }
          }
        })


        // Send Recurring, displays list of recurring sends
        .state('member.home.send/recurring/manage', {
          url: 'send/recurring/manage',
          data: {roles: ['authenticated', 'full'], overlay: true},
          abstract: true,
          views: {
            'overlay@': {
              templateUrl: 'app/views/member/shared/overlay/layout.html',
              controller: function($scope, OVERLAY){
                $scope.overlay = OVERLAY['member.home.send/recurring/manage'];
              }
            }
          }
        })
        .state('member.home.send/recurring/manage.list', {
          url: '',
          data: {roles: ['authenticated', 'full'], overlay: true},
          views: {
            'header@member.home.send/recurring/manage': {
              templateUrl: 'app/views/member/shared/overlay/header-default.html',
              controller: function($scope, OVERLAY){
                $scope.title = 'Your automatic sends';
                $scope.info = 'Here you can manage your automatic sends. You can remove or modify a send by clicking on one below.';
              }
            },
            'step@member.home.send/recurring/manage': {
              templateUrl: 'app/views/member/send/manage/list.html',
              controller: 'sendFundsRecurringListCtrl'
            },
            'side@member.home.send/recurring/manage': {
              templateUrl: 'app/views/member/shared/overlay/side-options.html',
              controller: function($scope){
                $scope.showManageBank = true;
                $scope.showAddBank = true;
              }
            }
          }
        })


        // Transfers manage, displays list of recurring sends
        .state('member.home.transfers/manage', {
          url: 'transfers/manage',
          data: {roles: ['authenticated', 'full'], overlay: true},
          abstract: true,
          views: {
            'overlay@': {
              templateUrl: 'app/views/member/shared/overlay/layout.html',
              controller: 'autoTransfersManageCtrl'
            }
          }
        })
        .state('member.home.transfers/manage.list', {
          url: '',
          data: {roles: ['authenticated', 'full'], overlay: true},
          views: {
            'header@member.home.transfers/manage': {
              templateUrl: 'app/views/member/shared/overlay/header-default.html',
              controller: function($scope){
                $scope.title = 'Your automatic transfers';
                $scope.info = 'Here you can manage your automatic transfers. You can remove or modify a transfer by clicking on one below.';
              }
            },
            'step@member.home.transfers/manage': {
              templateUrl: 'app/views/member/transfers/manage.html'
            },
            'side@member.home.transfers/manage': {
              templateUrl: 'app/views/member/shared/overlay/side-options.html',
              controller: function($scope){

                $scope.hideManageAutoBankLoads = $scope.brand.hideManageAutoBankLoads;
                $scope.hideManageAutoSends = $scope.brand.hideManageAutoSends;
                $scope.hideManageAutoWithdrawals = $scope.brand.hideManageAutoWithdrawals;

                if($scope.brand.hideManageAutoBankLoads && $scope.brand.hideManageAutoWithdrawals) {
                  $scope.showManageBank = false;
                  $scope.showAddBank = false;
                  $scope.hideOptionsTitle = true;
                } else {
                  $scope.showManageBank = true;
                  $scope.showAddBank = true;
                }

              }
            }
          }
        })

        .state('member.home.send/recurring/edit', {
          url: 'send/recurring/edit/{recurringId}',
          data: {roles: ['authenticated', 'primary'], overlay: true},
          abstract: true,
          views: {
            'overlay@': {
              templateUrl: 'app/views/member/shared/overlay/layout.html',
              controller: 'autoSendFundsCtrl'
            }
          }
        })
        .state('member.home.send/recurring/edit.step1', {
          url: '',
          data: {roles: ['authenticated', 'primary'], overlay: true},
          views: {
            'header@member.home.send/recurring/edit': {
              templateUrl: 'app/views/member/send/recurring/header-content.html',
              controller: function($scope, OVERLAY){
                $scope.title = 'Automatic Send Funds';
                $scope.info = 'Enter the amount, initial transfer date, and the frequency at which you would like this automatic send to occur.';
              }
            },
            'step@member.home.send/recurring/edit': {
              templateUrl: 'app/views/member/send/recurring/step2.html'
            },
            'side@member.home.send/recurring/edit': {
              templateUrl: 'app/views/member/shared/overlay/side-options.html',
              controller: function($scope, $state, $http, $stateParams, baseURI){
                $scope.showManageBank = true;
                $scope.showManageAutoTransfers = true;
                $scope.showRemoveTransfer = true;
              }
            },
            'footer@member.home.send/recurring/edit': {
              templateUrl: 'app/views/member/shared/overlay/footer.html',
              controller: function($scope, $state, $stateParams){
                $scope.mainBtn = {
                  title: 'NEXT',
                  attemptSubmission: true
                };
                $scope.cancel = true;
              }
            }
          }
        })
        .state('member.home.send/recurring/edit.step2', {
          url: '',
          data: {roles: ['authenticated', 'full'], overlay: true},
          views: {
            'header@member.home.send/recurring/edit': {
              templateUrl: 'app/views/member/send/recurring/header-content.html',
              controller: function($scope){
                $scope.title = 'Ok, let\'s review';
                $scope.info = 'We\'re almost done. Review everything below and click Save when you\'re ready';
              }
            },
            'step@member.home.send/recurring/edit': {
              templateUrl: 'app/views/member/send/recurring/step3.html'
            },
            'footer@member.home.send/recurring/edit': {
              templateUrl: 'app/views/member/shared/overlay/footer.html',
              controller: function($scope){
                $scope.mainBtn = {
                  title: 'SAVE',
                  processForm: true
                };
                $scope.cancel = true;
              }
            }
          }
        })
        .state('member.home.send/recurring/edit.confirmation', {
          url: '',
          data: {roles: ['authenticated', 'full'], overlay: true},
          views: {
            'header@member.home.send/recurring/edit': {
              templateUrl: 'app/views/member/send/recurring/header-content.html',
              controller: function ($scope){
                var startDate = moment($scope.$parent.formData.StartDate).format('dddd, MMMM DD YYYY');
                $scope.title = 'Your auto send has been updated!';
                $scope.info = 'Your auto sends will begin on ' + startDate + '.';
              }
            },
            'step@member.home.send/recurring/edit': {
              templateUrl: 'app/views/member/send/recurring/step3.html'
            },
            'side@member.home.send/recurring/edit': {
              templateUrl: 'app/views/member/shared/overlay/side-text.html'
            },
            'footer@member.home.send/recurring/edit': {
              templateUrl: 'app/views/member/shared/overlay/footer.html',
              controller: function($scope){
                $scope.close = true;
              }
            }
          }
        })



        // Request routes
        .state('member.home.request', {
          url: 'request',
          data: {roles: ['authenticated', 'full'], overlay: true},
          abstract: true,
          views: {
            'overlay@': {
              templateUrl: 'app/views/member/shared/overlay/layout.html',
              controller: 'requestFundsCtrl'
            }
          }
        })
        .state('member.home.request.step1', {
          url: '',
          data: {roles: ['authenticated', 'full'], overlay: true},
          views: {
            'header@member.home.request': {
              templateUrl: 'app/views/member/shared/overlay/header-search.html',
              controller: function ($scope){
                $scope.title = 'From Whom Do You Want To Request Money?';
                $scope.info = 'Start by searching for them in the box below. Request money from another ' + $scope.brand.programName + ' cardholder.';
              }
            },
            'step@member.home.request': {
              templateUrl: 'app/views/member/send/transfer/step1.html'
            },
            'side@member.home.request': {
              templateUrl: 'app/views/member/shared/overlay/side-options.html',
              controller: function ($scope){
                $scope.showSub = true;
              }
            }
          }
        })
        .state('member.home.request.step2', {
          url: '',
          data: {roles: ['authenticated', 'full'], overlay: true},
          views: {
            'header@member.home.request': {
              templateUrl: 'app/views/member/request/header-content.html',
              controller: function ($scope){
                $scope.title = 'Great, you\'re ready to move on';
                $scope.info = 'Simply enter the amount and then click Next. You can personalize it by adding a message. Personalized requests are well, more personal, and more likely to be fulfilled. And, don\'t forget to explain why or what you\'re asking for.';
              }
            },
            'step@member.home.request': {
              templateUrl: 'app/views/member/request/step2.html'
            },
            'side@member.home.request': {
              templateUrl: 'app/views/member/shared/overlay/side-options.html',
              controller: function ($scope){
                $scope.showAddMessage = true;

                $scope.addMessage = function(message){
                  $scope.formData.Note = message;
                  $scope.showAddMessageOption = false;
                };
              }
            },
            'footer@member.home.request': {
              templateUrl: 'app/views/member/shared/overlay/footer.html',
              controller: function($scope){
                $scope.mainBtn = {
                  attemptSubmission: true,
                  title: 'NEXT'
                };
                $scope.cancel = true;
              }
            }
          }
        })
        .state('member.home.request.step3', {
          url: '',
          data: {roles: ['authenticated', 'full'], overlay: true},
          views: {
            'header@member.home.request': {
              templateUrl: 'app/views/member/request/header-content.html',
              controller: function ($scope){
                $scope.title = 'Ok, we\'re ready to send out your request';
                $scope.info = 'Review your transfer below and click send when you\'re ready';
              }
            },
            'step@member.home.request': {
              templateUrl: 'app/views/member/request/step3.html'
            },
            'side@member.home.request': {
              templateUrl: 'app/views/member/shared/overlay/side-options.html',
              controller: function ($scope){
                $scope.showAddMessage = true;

                $scope.addMessage = function(message){
                  $scope.formData.Note = message;
                  $scope.showAddMessageOption = false;
                };
              }
            },
            'footer@member.home.request': {
              templateUrl: 'app/views/member/shared/overlay/footer.html',
              controller: function ($scope){
                $scope.mainBtn = {
                  processForm: true,
                  title: 'REQUEST'
                };
                $scope.btns = [{
                  title: 'EDIT',
                  state: 'member.home.request.step2'
                }];
                $scope.cancel = true;
              }
            }
          }
        })
        .state('member.home.request.step4', {
          url: '',
          data: {roles: ['authenticated', 'full'], overlay: true},
          views: {
            'header@member.home.request': {
              templateUrl: 'app/views/member/request/header-content.html',
              controller: function ($scope){
                $scope.title = 'Your request has been sent!';
                $scope.info = 'Now wasn\'t that easy?';
              }
            },
            'step@member.home.request': {
              templateUrl: 'app/views/member/request/step4.html'
            },
            'side@member.home.request': {
              templateUrl: 'app/views/member/shared/overlay/side-text.html',
              controller: function ($scope){
                $scope.title = 'How does this work?';
                $scope.info = 'It\'s easy! The recipient will receive an email with instructions and a link to send money to you.';
              }
            },
            'footer@member.home.request': {
              templateUrl: 'app/views/member/shared/overlay/footer.html',
              controller: function ($scope){
                $scope.close = true;
              }
            }
          }
        })

        // Profile Routes
        .state('member.home.profile', {
          url: 'profile',
          data: {roles: ['authenticated', 'full'], overlay: true},
          abstract: true,
          views: {
            'overlay@': {
              templateUrl: 'app/views/member/shared/overlay/layout.html',
              controller: 'profileCtrl'
            }
          }
        })
        .state('member.home.profile.step1', {
          url: '',
          data: {roles: ['authenticated', 'full'], overlay: true},
          views: {
            'header@member.home.profile': {
              templateUrl: 'app/views/member/shared/overlay/header-default.html',
              controller: function ($scope){
                $scope.title = 'My Information and Settings';
                $scope.info = 'Here you can update your mailing address for the selected card.';
              }
            },
            'step@member.home.profile': {
              templateUrl: 'app/views/member/profile/account/step1.html'
            },
            'side@member.home.profile': {
              templateUrl: 'app/views/member/shared/overlay/side-options.html',
              controller: function ($scope){
                $scope.showChangePin = true;
                $scope.showSms = true;
              }
            },
            'footer@member.home.profile': {
              templateUrl: 'app/views/member/shared/overlay/footer.html',
              controller: function ($scope){
                $scope.mainBtn = {
                  title: 'NEXT',
                  attemptSubmission: true
                };
                $scope.cancel = true;
              }
            }
          }
        })
        .state('member.home.profile.step2', {
          url: '',
          data: {roles: ['authenticated', 'full'], overlay: true},
          views: {
            'header@member.home.profile': {
              templateUrl: 'app/views/member/shared/overlay/header-default.html',
              controller: function ($scope){
                $scope.title = 'Ok, let\'s review';
                $scope.info = 'We\'re almost done. Review everything below and click Save when you\'re ready.';
              }
            },
            'step@member.home.profile': {
              templateUrl: 'app/views/member/profile/account/step2.html'
            },
            'side@member.home.profile': {
              templateUrl: 'app/views/member/shared/overlay/side-text.html',
              controller: 'profileSidebarCtrl'
            },
            'footer@member.home.profile': {
              templateUrl: 'app/views/member/shared/overlay/footer.html',
              controller: function ($scope){
                $scope.mainBtn = {
                  processForm: true,
                  title: 'SAVE'
                };
                $scope.btns = [{
                  title: 'EDIT',
                  state: 'member.home.profile.step1'
                }];
                $scope.cancel = true;
              }
            }
          }
        })
        .state('member.home.profile.confirmation', {
          url: '',
          data: {roles: ['authenticated', 'full'], overlay: true},
          views: {
            'header@member.home.profile': {
              templateUrl: 'app/views/member/shared/overlay/header-default.html',
              controller: function ($scope){
                $scope.title = 'Your profile has been updated';
                $scope.info = 'Now wasn\'t that easy';
              }
            },
            'step@member.home.profile': {
              templateUrl: 'app/views/member/profile/account/step2.html'
            },
            'side@member.home.profile': {
              templateUrl: 'app/views/member/shared/overlay/side-text.html',
              controller: 'profileSidebarCtrl'
            },
            'footer@member.home.profile': {
              templateUrl: 'app/views/member/shared/overlay/footer.html',
              controller: function ($scope){
                $scope.close = true;
              }
            }
          }
        })

        // Profile SMS routes
        .state('member.home.profile/smsmanage', {
          url: 'profile/smsmanage',
          data: {roles: ['authenticated', 'full'], overlay: true},
          abstract: true,
          views: {
            'overlay@': {
              templateUrl: 'app/views/member/shared/overlay/layout.html',
              controller: 'smsManageCtrl'
            }
          }
        })
        .state('member.home.profile/smsmanage.step1', {
          url: '',
          data: {roles: ['authenticated', 'full'], overlay: true},
          views: {
            'header@member.home.profile/smsmanage': {
              templateUrl: 'app/views/member/shared/overlay/header-default.html',
              controller: function ($scope){
                $scope.title = 'Subscribe to real-time text alerts';
                $scope.info = 'Receive a text message on your phone for each transaction you make. Stay updated on purchases and your balance with real-time text alerts.';
              }
            },
            'step@member.home.profile/smsmanage': {
              templateUrl: 'app/views/member/profile/smsmanage/step1.html'
            },
            'side@member.home.profile/smsmanage': {
              templateUrl: 'app/views/member/shared/overlay/side-options.html',
              controller: function($scope){
                $scope.showProfile = true;
              }
            },
            'footer@member.home.profile/smsmanage': {
              templateUrl: 'app/views/member/shared/overlay/footer.html',
              controller: function ($scope){
                $scope.mainBtn = {
                  title: 'NEXT',
                  attemptSubmission: true
                };
                $scope.cancel = true;
              }
            }
          }
        })
        .state('member.home.profile/smsmanage.step2', {
          url: '',
          data: {roles: ['authenticated', 'full'], overlay: true},
          views: {
            'header@member.home.profile/smsmanage': {
              templateUrl: 'app/views/member/shared/overlay/header-default.html',
              controller: function ($scope){
                $scope.title = 'Subscribe to real-time text alerts';
                $scope.info = 'Receive a text message on your phone for each transaction you make. Stay updated on purchases and your balance with real-time text alerts.';
              }
            },
            'step@member.home.profile/smsmanage': {
              templateUrl: 'app/views/member/profile/smsmanage/step2.html'
            },
            'side@member.home.profile/smsmanage': {
              templateUrl: 'app/views/member/shared/overlay/side-options.html',
              controller: function($scope){
                $scope.showProfile = true;
              }
            },
            'footer@member.home.profile/smsmanage': {
              templateUrl: 'app/views/member/shared/overlay/footer.html',
              controller: function ($scope){
                $scope.cancel = true;
                $scope.btns = [{
                  title: 'EDIT',
                  state: 'member.home.profile/smsmanage.step1'
                }];
                $scope.mainBtn = {
                  title: 'SAVE',
                  processForm: true
                };
              }
            }
          }
        })
        .state('member.home.profile/smsmanage.step3', {
          url: '',
          data: {roles: ['authenticated', 'full'], overlay: true},
          views: {
            'header@member.home.profile/smsmanage': {
              templateUrl: 'app/views/member/shared/overlay/header-default.html',
              controller: function ($scope){
                $scope.title = 'Your real-time text alerts have been updated';
                $scope.info = 'Now wasn\'t that easy';
              }
            },
            'step@member.home.profile/smsmanage': {
              templateUrl: 'app/views/member/profile/smsmanage/step2.html'
            },
            'side@member.home.profile/smsmanage': {
              templateUrl: 'app/views/member/shared/overlay/side-options.html',
              controller: function($scope){
                $scope.showProfile = true;
              }
            },
            'footer@member.home.profile/smsmanage': {
              templateUrl: 'app/views/member/shared/overlay/footer.html',
              controller: function ($scope){
                $scope.close = true;
              }
            }
          }
        })


        // Profile View statements
        .state('member.home.profile/statements', {
          url: 'profile/statements',
          data: {roles: ['authenticated', 'full'], overlay: true},
          abstract: true,
          views: {
            'overlay@': {
              templateUrl: 'app/views/member/shared/overlay/layout.html',
              controller: 'viewStatementsCtrl',
              controllerAs: 'viewStatements',
            }
          }
        })
        .state('member.home.profile/statements.step1', {
          url: '',
          data: {roles: ['authenticated', 'full'], overlay: true},
          views: {
            'header@member.home.profile/statements': {
              templateUrl: 'app/views/member/shared/overlay/header-default.html',
              controller: function ($scope){
                $scope.title = 'Your statements';
                $scope.info = 'View, download, or print your monthly statements below.';
              }
            },
            'step@member.home.profile/statements': {
              templateUrl: 'app/views/member/profile/statements/step1.html'
            },
            'footer@member.home.profile/statements': {
              templateUrl: 'app/views/member/shared/overlay/footer.html'
            }
          }
        })


        // Profile View Fees
        .state('member.home.profile/feesummary', {
          url: 'profile/feesummary',
          data: {roles: ['authenticated', 'full'], overlay: true},
          abstract: true,
          views: {
            'overlay@': {
              templateUrl: 'app/views/member/shared/overlay/layout.html',
              controller: 'viewFeeSummaryCtrl',
              controllerAs: 'viewFeeSummary',
            }
          }
        })
        .state('member.home.profile/feesummary.step1', {
          url: '',
          data: {roles: ['authenticated', 'full'], overlay: true},
          views: {
            'header@member.home.profile/feesummary': {
              templateUrl: 'app/views/member/shared/overlay/header-default.html',
              controller: function ($scope){
                $scope.title = 'Your fee summary';
                $scope.info = 'This is a summary of fees for this account.';
              }
            },
            'step@member.home.profile/feesummary': {
              templateUrl: 'app/views/member/profile/feesummary/step1.html'
            },
            'footer@member.home.profile/feesummary': {
              templateUrl: 'app/views/member/shared/overlay/footer.html'
            }
          }
        })


        // Profile Change Pin
        .state('member.home.profile/changepin', {
          url: 'profile/changepin',
          data: {roles: ['authenticated', 'full'], overlay: true},
          abstract: true,
          views: {
            'overlay@': {
              templateUrl: 'app/views/member/shared/overlay/layout.html',
              controller: 'changePinCtrl'
            }
          }
        })
        .state('member.home.profile/changepin.step1', {
          url: '',
          data: {roles: ['authenticated', 'full'], overlay: true},
          views: {
            'header@member.home.profile/changepin': {
              templateUrl: 'app/views/member/shared/overlay/header-default.html',
              controller: function ($scope){
                $scope.title = 'Change your PIN';
                $scope.info = 'You can change your PIN by typing your new PIN. Confirm your new PIN by re-entering it in the last box.';
              }
            },
            'step@member.home.profile/changepin': {
              templateUrl: 'app/views/member/profile/changepin/step1.html'
            },
            'side@member.home.profile/changepin': {
              templateUrl: 'app/views/member/shared/overlay/side-text.html',
              controller: function ($scope){
                $scope.title = 'PIN tips';
                $scope.info = 'Your PIN must be four (4) numbers long.  Keep your account safe with a strong PIN. Don\'t use your SSN or your date of birth in your PIN.';
              }
            },
            'footer@member.home.profile/changepin': {
              templateUrl: 'app/views/member/shared/overlay/footer.html',
              controller: function ($scope){
                $scope.mainBtn = {
                  attemptSubmission: true,
                  title: 'SAVE'
                };
                $scope.cancel = true;
              }
            }
          }
        })
        .state('member.home.profile/changepin.confirmation', {
          url: '',
          data: {roles: ['authenticated', 'full'], overlay: true},
          views: {
            'header@member.home.profile/changepin': {
              templateUrl: 'app/views/member/shared/overlay/header-default.html',
              controller: function ($scope){
                $scope.title = 'Your PIN has been updated';
                $scope.info = 'Now wasn\'t that easy';
              }
            },
            'step@member.home.profile/changepin': {
              templateUrl: 'app/views/member/profile/changepin/step1.html'
            },
            'side@member.home.profile/changepin': {
              templateUrl: 'app/views/member/shared/overlay/side-text.html',
              controller: function($scope){
                $scope.title = 'Please Note';
                $scope.info = 'It will take between 30-40 minutes for your new PIN to work for purchases and ATM withdrawals.';
              }
            },
            'footer@member.home.profile/changepin': {
              templateUrl: 'app/views/member/shared/overlay/footer.html',
              controller: function ($scope){
                $scope.close = true;
              }
            }
          }
        })


        // Profile Change Password
        .state('member.home.profile/password', {
          url: 'profile/password',
          data: {roles: ['authenticated', 'full'], overlay: true},
          abstract: true,
          views: {
            'overlay@': {
              templateUrl: 'app/views/member/shared/overlay/layout.html',
              controller: 'changePasswordCtrl'
            }
          }
        })
        .state('member.home.profile/password.step1', {
          url: '',
          data: {roles: ['authenticated', 'full'], overlay: true},
          views: {
            'header@member.home.profile/password': {
              templateUrl: 'app/views/member/shared/overlay/header-default.html',
              controller: function ($scope){
                $scope.title = 'Create a new password';
                $scope.info = 'You can change your password by typing your current password followed by your new password. Confirm your new password by re-entering it in the last box.';
              }
            },
            'step@member.home.profile/password': {
              templateUrl: 'app/views/member/profile/password/step1.html'
            },
            'side@member.home.profile/password': {
              templateUrl: 'app/views/member/shared/overlay/side-text.html',
              controller: function ($scope){
                $scope.title = 'Password tips';
                $scope.info = 'Your password must be at least eight (8) characters long and contain at least one (1) letter and one (1) number.  Keep your account safe with a strong password. Don\'t use your name or your date of birth in your password. Also, we recommend using both upper and lowercase characters.';
              }
            },
            'footer@member.home.profile/password': {
              templateUrl: 'app/views/member/shared/overlay/footer.html',
              controller: function ($scope){
                $scope.mainBtn = {
                  attemptSubmission: true,
                  title: 'SAVE'
                };
                $scope.cancel = true;
              }
            }
          }
        })
        .state('member.home.profile/password.confirmation', {
          url: '',
          data: {roles: ['authenticated', 'full'], overlay: true},
          views: {
            'header@member.home.profile/password': {
              templateUrl: 'app/views/member/shared/overlay/header-default.html',
              controller: function ($scope){
                $scope.title = 'Your password has been updated';
                $scope.info = 'Now wasn\'t that easy';
              }
            },
            'step@member.home.profile/password': {
              templateUrl: 'app/views/member/profile/password/step1.html'
            },
            'footer@member.home.profile/password': {
              templateUrl: 'app/views/member/shared/overlay/footer.html',
              controller: function ($scope){
                $scope.close = true;
              }
            }
          }
        })



        // Profile Reissue Card
        .state('member.home.profile/reissue', {
          url: 'profile/reissue',
          data: {roles: ['authenticated', 'full'], overlay: true},
          abstract: true,
          views: {
            'overlay@': {
              templateUrl: 'app/views/member/shared/overlay/layout.html',
              controller: 'reissueCtrl'
            }
          }
        })
        .state('member.home.profile/reissue.step1', {
          url: '',
          data: {roles: ['authenticated', 'full'], overlay: true},
          views: {
            'header@member.home.profile/reissue': {
              templateUrl: 'app/views/member/shared/overlay/header-default.html',
              controller: function ($scope){
                $scope.title = 'Reissue Card';
                $scope.info = $scope.headerInfo; // set in reissueCtrl
              }
            },
            'step@member.home.profile/reissue': {
              templateUrl: 'app/views/member/profile/reissue/step1.html'
            },
            'side@member.home.profile/reissue': {
              templateUrl: 'app/views/member/profile/reissue/step1-side-text.html'
            },
            'footer@member.home.profile/reissue': {
              templateUrl: 'app/views/member/shared/overlay/footer.html',
              controller: function ($scope){
                $scope.mainBtn = {
                  attemptSubmission: true,
                  title: 'NEXT'
                };
                $scope.cancel = true;
              }
            }
          }
        })
        .state('member.home.profile/reissue.step2', {
          url: '',
          data: {roles: ['authenticated', 'full'], overlay: true},
          views: {
            'header@member.home.profile/reissue': {
              templateUrl: 'app/views/member/profile/reissue/step2-header-text.html',
              controller: 'reissueHeaderCtrl'
            },
            'step@member.home.profile/reissue': {
              templateUrl: 'app/views/member/profile/reissue/step2.html'
            },
            'side@member.home.profile/reissue': {
              templateUrl: 'app/views/member/profile/reissue/step2-side-options.html',
              controller: function($scope){
                $scope.showAddress = true;
              }
            },
            'footer@member.home.profile/reissue': {
              templateUrl: 'app/views/member/shared/overlay/footer.html',
              controller: function ($scope){
                $scope.mainBtn = {
                  processForm: true,
                  title: 'REISSUE'
                };
                $scope.cancel = true;
              }
            }
          }
        })
        .state('member.home.profile/reissue.confirmation', {
          url: '',
          data: {roles: ['authenticated', 'full'], overlay: true},
          views: {
            'header@member.home.profile/reissue': {
              templateUrl: 'app/views/member/shared/overlay/header-default.html',
              controller: function ($scope){
                $scope.title = 'Congratulations! You have reissued your card.';
                $scope.info = 'Your reissued card(s) will arrive in 5-8 business days.';
              }
            },
            'step@member.home.profile/reissue': {
              templateUrl: 'app/views/member/profile/reissue/step2.html'
            },
            'side@member.home.profile/reissue': {
              templateUrl: 'app/views/member/profile/reissue/confirmation-side-text.html'
            },
            'footer@member.home.profile/reissue': {
              templateUrl: 'app/views/member/shared/overlay/footer.html',
              controller: function ($scope){
                $scope.close = true;
              }
            }
          }
        })

        .state('member.home.profile/activate', {
          url: 'profile/activate',
          data: {roles: ['authenticated', 'full'], overlay: true},
          abstract: true,
          views: {
            'overlay@': {
              templateUrl: 'app/views/member/shared/overlay/layout.html',
              controller: 'activateCardCtrl'
            }
          }
        })
        .state('member.home.profile/activate.step1', {
          url: '',
          data: {roles: ['authenticated', 'full'], overlay: true},
          views: {
            'header@member.home.profile/activate': {
              templateUrl: 'app/views/member/shared/overlay/header-default.html',
              controller: function ($scope){
                $scope.title = 'Start using your card today';
                $scope.info = 'Your card can be activated by entering the ' + $scope.brand.fullProgramName + ' Number, Card Security Code and Card Valid Thru Date found on your card.';
              }
            },
            'step@member.home.profile/activate': {
              templateUrl: 'app/views/member/profile/activate/step1.html'
            },
            'side@member.home.profile/activate': {
              templateUrl: 'app/views/member/shared/overlay/side-text.html',
              controller: function ($scope, $stateParams){
                $scope.title = 'Hey friend';
                $scope.info = 'You must activate this card before you can use it to make purchases.';
              }
            },
            'footer@member.home.profile/activate': {
              templateUrl: 'app/views/member/shared/overlay/footer.html'
            }
          }
        })


        // Upgrade routes
        .state('member.home.upgrade', {
          url: 'upgrade',
          data: {roles: ['authenticated', 'full'], overlay: true},
          abstract: true,
          views: {
            'overlay@': {
              templateUrl: 'app/views/member/shared/overlay/layout.html',
              controller: 'upgradeCardCtrl'
            }
          }
        })
        .state('member.home.upgrade.step1', {
          url: '',
          data: {roles: ['authenticated', 'full'], overlay: true},
          views: {
            'header@member.home.upgrade': {
              templateUrl: 'app/views/member/upgrade/header.html'
            },
            'step@member.home.upgrade': {
              templateUrl: 'app/views/member/upgrade/step1.html'
            },
            'side@member.home.upgrade': {
              templateUrl: 'app/views/member/shared/overlay/side-text.html',
              controller: function ($scope){
                $scope.title = 'Why upgrade a gift card?';
                $scope.info = 'Once you\'ve completed this process and created a reloadable ' +
                    $scope.brand.commonProgramName + ' account, you\'ll be able to transfer any ' +
                    'of your gift card balances to your new reloadable account. From there, you ' +
                    'can transfer money to your bank accounts or use your new ' +
                    $scope.brand.commonProgramName + ' at ATMs.';
                $scope.info2 = 'We think you\'ll love your new ' + $scope.brand.commonProgramName +
                    '. It\'s great for personal budgeting. Plus, you can send money instantly to ' +
                    'any other ' + $scope.brand.commonProgramName + ' member and add up to 5 ' +
                    'sub-cards for advanced budgeting or allowances.';
              }
            },
            'footer@member.home.upgrade': {
              templateUrl: 'app/views/member/shared/overlay/footer.html',
              controller: function ($scope){
                $scope.mainBtn = {
                  title: 'NEXT',
                  next: 'member.home.upgrade.step2',
                  attemptSubmission: true
                };
                $scope.cancel = true;
              }
            }
          }
        })
        .state('member.home.upgrade.step2', {
          url: '',
          data: {roles: ['authenticated', 'full'], overlay: true},
          views: {
            'header@member.home.upgrade': {
              templateUrl: 'app/views/member/upgrade/header.html'
            },
            'step@member.home.upgrade': {
              templateUrl: 'app/views/member/upgrade/step2.html'
            },
            'side@member.home.upgrade': {
              templateUrl: 'app/views/member/shared/overlay/side-text.html',
              controller: function ($scope){
                $scope.title = 'Why upgrade a gift card?';
                $scope.info = 'Once you\'ve completed this process and created a reloadable ' +
                    $scope.brand.commonProgramName + ' account, you\'ll be able to transfer any ' +
                    'of your gift card balances to your new reloadable account. From there, you ' +
                    'can transfer money to your bank accounts or use your new ' +
                    $scope.brand.commonProgramName + ' at ATMs.';
                $scope.info2 = 'We think you\'ll love your new ' + $scope.brand.commonProgramName +
                    '. It\'s great for personal budgeting. Plus, you can send money instantly to ' +
                    'any other ' + $scope.brand.commonProgramName + ' member and add up to 5 ' +
                    'sub-cards for advanced budgeting or allowances.';
              }
            },
            'footer@member.home.upgrade': {
              templateUrl: 'app/views/member/shared/overlay/footer.html',
              controller: function ($scope){
                $scope.mainBtn = {
                  title: 'UPGRADE',
                  attemptSubmission: true
                };
                $scope.btns = [{
                  title: 'BACK',
                  state: 'member.home.upgrade.step1'
                }];
                $scope.cancel = true;
              }
            }
          }
        })
        .state('member.home.upgrade.success', {
          url: '',
          data: {roles: ['authenticated', 'full'], overlay: true},
          views: {
            'header@member.home.upgrade': {
              templateUrl: 'app/views/member/shared/overlay/header-default.html',
              controller: function ($scope){
                $scope.title = 'Success!';
                $scope.info = 'Your card has been upgraded!';
              }
            },
            'step@member.home.upgrade': {
              templateUrl: 'app/views/member/upgrade/success.html'
            },
            'side@member.home.upgrade': {
              templateUrl: 'app/views/member/shared/overlay/side-text.html',
              controller: function ($scope){
                $scope.title = 'Note';
                $scope.info = 'Please allow 5-8 business days to receive your upgraded ' +
                    $scope.brand.fullProgramName + ' in the mail.';
              }
            },
            'footer@member.home.upgrade': {
              templateUrl: 'app/views/member/shared/overlay/footer.html',
              controller: function ($scope){

              }
            }
          }
        })
        .state('member.home.upgrade.cipFailure', {
          url: '',
          data: {roles: ['authenticated', 'full'], overlay: true},
          views: {
            'header@member.home.upgrade': {
              templateUrl: 'app/views/member/shared/overlay/header-default.html',
              controller: function ($scope){
                $scope.title = 'Sorry, there was a problem';
                $scope.info = 'We were unable to upgrade your account. Please read below for more information.';
              }
            },
            'step@member.home.upgrade': {
              templateUrl: 'app/views/member/upgrade/cip-failure.html'
            },
            'footer@member.home.upgrade': {
              templateUrl: 'app/views/member/shared/overlay/footer.html',
              controller: function ($scope){
                $scope.close = true;
              }
            }
          }
        })


        // Subaccount Add Routes
        .state('member.home.subaccount/add', {
          url: 'subaccount/add',
          data: {roles: ['authenticated', 'primary'], overlay: true},
          abstract: true,
          views: {
            'overlay@': {
              templateUrl: 'app/views/member/shared/overlay/layout.html',
              controller: 'addSubCtrl'
            }
          }
        })
        .state('member.home.subaccount/add.step1', {
          url: '',
          resolve: {
            data: function(Session){
              return Session.getExpense();
            }
          },
          data: {roles: ['authenticated', 'primary'], overlay: true},
          views: {
            'header@member.home.subaccount/add': {
              templateUrl: 'app/views/member/shared/overlay/header-default.html',
              controller: function ($scope, data){
                $scope.title = 'Adding Cards';
                $scope.info = data ? 'Add cards for employees, specific purchases or budgets. Please provide a first and last name below. This name will be printed on the card. You may use a generic name (e.g. "Employee 012")' : 'You can add up to five sub-cards. It is easy. Just enter their first and last name below and a new card will be delivered to you.';
              }
            },
            'step@member.home.subaccount/add': {
              templateUrl: 'app/views/member/subaccount/add/step1.html'
            },
            'side@member.home.subaccount/add': {
              templateUrl: 'app/views/member/shared/overlay/side-text.html',
              controller: function ($scope){
                $scope.title = 'What are my options?';
                $scope.info = '<p><strong>Virtual Card</strong> If a virtual card is selected, then a plastic card will not be mailed to you. Instead you will have immediate access to the virtual card number through this web portal. <p><strong>Cash Access</strong> If you disable cash access, then the cardholder will not be able to use the card at ATMs or for other cash withdrawals.';
              }
            },
            'footer@member.home.subaccount/add': {
              templateUrl: 'app/views/member/shared/overlay/footer.html',
              controller: function ($scope){
                $scope.mainBtn = {
                  title: 'NEXT',
                  attemptSubmission: true
                };
                $scope.cancel = true;
              }
            }
          }
        })
        .state('member.home.subaccount/add.step2', {
          url: '',
          data: {roles: ['authenticated', 'primary'], overlay: true},
          views: {
            'header@member.home.subaccount/add': {
              templateUrl: 'app/views/member/shared/overlay/header-default.html',
              controller: function ($scope){
                $scope.title = 'Ok, let\'s review';
                $scope.info = 'We\'re almost done. Review everything below and click Add when you\'re ready';
              }
            },
            'step@member.home.subaccount/add': {
              templateUrl: 'app/views/member/subaccount/add/step2.html'
            },
            'side@member.home.subaccount/add': {
              templateUrl: 'app/views/member/shared/overlay/side-text.html',
              controller: function ($scope){
                $scope.title = 'Important Tip';
                $scope.info = 'The primary cardholder is ultimately responsible for all activity on sub-cards and only the primary cardholder can contact customer service.';
              }
            },
            'footer@member.home.subaccount/add': {
              templateUrl: 'app/views/member/shared/overlay/footer.html',
              controller: function ($scope){
                $scope.mainBtn = {
                  title: 'ADD',
                  processForm: true
                };
                $scope.btns = [{
                  title: 'EDIT',
                  state: 'member.home.subaccount/add.step1'
                }];
                $scope.cancel = true;
              }
            }
          }
        })
        .state('member.home.subaccount/add.step3', {
          url: '',
          data: {roles: ['authenticated', 'primary'], overlay: true},
          views: {
            'header@member.home.subaccount/add': {
              templateUrl: 'app/views/member/shared/overlay/header-default.html',
              controller: function ($scope){
                $scope.title = 'Your card has been ordered';
                $scope.info = 'Now wasn\'t that easy';
              }
            },
            'step@member.home.subaccount/add': {
              templateUrl: 'app/views/member/subaccount/add/step2.html'
            },
            'side@member.home.subaccount/add': {
              templateUrl: 'app/views/member/subaccount/add/side-text.html',
              controller: function ($scope, $http, baseURI){
                $http.get(baseURI + 'cardholder/profile')
                  .then(function(resp){
                    var data = resp.data;
                      if(data.Success){
                        $scope.address1 = data.Data.Address1;
                        $scope.address2 = data.Data.Address2;
                        $scope.city = data.Data.City;
                        $scope.state = data.Data.StateCode.replace(' ', '');
                        $scope.zip = data.Data.PostalCode;
                      }
                    });
              }
            },
            'footer@member.home.subaccount/add': {
              templateUrl: 'app/views/member/shared/overlay/footer.html',
              controller: function ($scope){
                $scope.close = true;
              }
            }
          }
        })
        //additonal account verification needed
        .state('member.home.profile/verification', {
          url: 'profile/verification',
          data: {roles: ['authenticated', 'full'], overlay: true},
          abstract: true,
          views: {
            'overlay@': {
              templateUrl: 'app/views/member/shared/overlay/layout.html',
              controller: 'verificationCtrl'
            }
          }
        })
        .state('member.home.profile/verification.step1', {
          url: '/step1',
          data: {roles: ['authenticated', 'full'], overlay: true},
          views: {
            'header@member.home.profile/verification': {
              templateUrl: 'app/views/member/shared/overlay/header-default.html',
              controller: function ($scope, $stateParams, Session){
                if(Session.getIsFraudBlocked()){
                  $scope.title = 'Suspended Account';
                }
                else if(Session.getEnrollmentErrorCode() === 150){
                  $scope.title = 'Additional Information Required';
                }
                else{
                  $scope.title = 'You Are Good To Go!';
                }
              }
            },
            'step@member.home.profile/verification': {
              templateUrl: 'app/views/member/profile/verification/step1.html'
            },
            'side@member.home.profile/verification': {
              templateUrl: 'app/views/member/shared/overlay/side-text.html',
              controller: function ($scope, $stateParams){
                $scope.title = 'Contact Us';
                $scope.info = 'If you have any questions, please call us at ' + $scope.brand.programContactPhone + ', 7am - 7pm Central Time, Monday-Friday, or email us at '+ $scope.brand.programContactEmail;
              }
            },
            'footer@member.home.profile/verification': {
              templateUrl: 'app/views/member/profile/verification/footer.html'
            }
          }
        })
        .state('member.home.profile/verification.step2', {
          url: '/step2',
          data: {roles: ['authenticated', 'full'], overlay: true},
          views: {
            'header@member.home.profile/verification': {
              templateUrl: 'app/views/member/shared/overlay/header-default.html',
              controller: function ($scope){
                $scope.title = 'Follow the verification steps on your phone';
              }
            },
            'step@member.home.profile/verification': {
              templateUrl: 'app/views/member/profile/verification/step2.html'
            },
            'side@member.home.profile/verification': {
              templateUrl: 'app/views/member/shared/overlay/side-text.html',
              controller: function ($scope, $stateParams){
                $scope.title = 'Contact Us';
                $scope.info = 'If you have any questions, please call us at ' + $scope.brand.programContactPhone + ', 7am - 7pm Central Time, Monday-Friday, or email us at '+ $scope.brand.programContactEmail;
              }
            }
          }
        })
        .state('member.home.profile/verification.step3', {
          url: '/step3',
          data: {roles: ['authenticated', 'full'], overlay: true},
          views: {
            'header@member.home.profile/verification': {
              templateUrl: 'app/views/member/shared/overlay/header-default.html',
              controller: function ($scope, $stateParams, Session){
                $scope.title = 'Success!';
                $scope.info = 'Verification Successful';
              }
            },
            'step@member.home.profile/verification': {
              templateUrl: 'app/views/member/profile/verification/step3.html'
            },
            'side@member.home.profile/verification': {
              templateUrl: 'app/views/member/shared/overlay/side-text.html',
              controller: function ($scope, $stateParams){
                $scope.title = 'Contact Us';
                $scope.info = 'If you have any questions, please call us at ' + $scope.brand.programContactPhone + ', 7am - 7pm Central Time, Monday-Friday, or email us at '+ $scope.brand.programContactEmail;
              }
            },
            'footer@member.home.profile/verification': {
              templateUrl: 'app/views/member/profile/verification/footer.html',
              controller: function($scope){
                $scope.verificationFooterResponseNext = false;
                $scope.okBtn = {
                  title: 'Ok'
                };
              }
            }
          }
        })
        .state('member.home.profile/verification.submitted', {
          url: '/submitted',
          data: {roles: ['authenticated', 'full'], overlay: true},
          views: {
            'header@member.home.profile/verification': {
              templateUrl: 'app/views/member/shared/overlay/header-default.html',
              controller: function ($scope, $stateParams, Session){
                $scope.title = 'Verification Processing';
              }
            },
            'step@member.home.profile/verification': {
              templateUrl: 'app/views/member/profile/verification/submitted.html',
              controller: function ($scope, $stateParams){
                $scope.title = 'Verification Processing';
              }
            },
            'side@member.home.profile/verification': {
              templateUrl: 'app/views/member/shared/overlay/side-text.html',
              controller: function ($scope, $stateParams){
                $scope.title = 'Contact Us';
                $scope.info = 'If you have any questions, please call us at ' + $scope.brand.programContactPhone + ', 7am - 7pm Central Time, Monday-Friday, or email us at '+ $scope.brand.programContactEmail;
              }
            }
          }
        })
        .state('member.home.profile/verification.denied', {
          url: '/denied',
          data: {roles: ['authenticated', 'full'], overlay: true},
          views: {
            'header@member.home.profile/verification': {
              templateUrl: 'app/views/member/shared/overlay/header-default.html',
              controller: function ($scope, $stateParams, Session){
                $scope.title = 'Verification Failed';
              }
            },
            'step@member.home.profile/verification': {
              templateUrl: 'app/views/member/profile/verification/denied.html',
              controller: function ($scope, $stateParams){
                $scope.title = 'Denied Verification';
              }
            },
            'side@member.home.profile/verification': {
              templateUrl: 'app/views/member/shared/overlay/side-text.html',
              controller: function ($scope, $stateParams){
                $scope.title = 'Contact Us';
                $scope.info = 'If you have any questions, please call us at ' + $scope.brand.programContactPhone + ', 7am - 7pm Central Time, Monday-Friday, or email us at '+ $scope.brand.programContactEmail;
              }
            }
          }
        })
        .state('member.home.profile/verification.review', {
          url: '/review',
          data: {roles: ['authenticated', 'full'], overlay: true},
          views: {
            'header@member.home.profile/verification': {
              templateUrl: 'app/views/member/shared/overlay/header-default.html',
              controller: function ($scope, $stateParams, Session){
                $scope.title = 'Verification Documents Need Review';
              }
            },
            'step@member.home.profile/verification': {
              templateUrl: 'app/views/member/profile/verification/review.html',
              controller: function ($scope, $stateParams){
                $scope.title = 'Review Verification';
              }
            },
            'side@member.home.profile/verification': {
              templateUrl: 'app/views/member/shared/overlay/side-text.html',
              controller: function ($scope, $stateParams){
                $scope.title = 'Contact Us';
                $scope.info = 'If you have any questions, please call us at ' + $scope.brand.programContactPhone + ', 7am - 7pm Central Time, Monday-Friday, or email us at '+ $scope.brand.programContactEmail;
              }
            }
          }
        })
        // atm access
        .state('member.home.profile/atm', {
          url: 'profile/atm',
          data: {roles: ['authenticated', 'full'], overlay: true},
          abstract: true,
          views: {
            'overlay@': {
              templateUrl: 'app/views/member/shared/overlay/layout.html',
              controller: 'atmAccessCtrl'
            }
          }
        })
        .state('member.home.profile/atm.step1', {
          url: '',
          data: {roles: ['authenticated', 'full'], overlay: true},
          views: {
            'header@member.home.profile/atm': {
              templateUrl: 'app/views/member/shared/overlay/header-default.html',
              controller: function ($scope){
                $scope.title = 'ATM Access';
                $scope.info = 'You can easily enable or disable ATM access for your cards here.';
              }
            },
            'step@member.home.profile/atm': {
              templateUrl: 'app/views/member/profile/atm/step1.html'
            },
            'side@member.home.profile/atm': {
              templateUrl: 'app/views/member/shared/overlay/side-text.html',
              controller: function ($scope, $stateParams){
                $scope.title = 'ATM Tips';
                $scope.info = 'There are daily and per transaction limits for cash withdrawals at ATMs on your Akimbo Card account. Akimbo will not permit withdraws that exceed these limits. If you are declined at an ATM, we recommend trying again with a smaller withdrawal amount.\n\nATM Withdrawal Limits:\n$705 per day\n\nNote: These limits include any fee charged by the ATM.';
              }
            },
            'footer@member.home.profile/atm': {
              templateUrl: 'app/views/member/shared/overlay/footer.html',
              controller: function($scope){
                $scope.mainBtn = {
                  processForm: true,
                  title: 'SAVE'
                };
                $scope.close = true;
              }
            }
          }
        })
        .state('member.home.profile/atm.step2', {
          url: '',
          data: {roles: ['authenticated', 'full'], overlay: true},
          views: {
            'header@member.home.profile/atm': {
              templateUrl: 'app/views/member/shared/overlay/header-default.html',
              controller: function ($scope){
                $scope.title = 'ATM Access';
                $scope.info = 'You can easily enable or disable ATM access for your cards here.';
              }
            },
            'step@member.home.profile/atm': {
              templateUrl: 'app/views/member/profile/atm/step2.html'
            },
            'side@member.home.profile/atm': {
              templateUrl: 'app/views/member/shared/overlay/side-text.html',
              controller: function ($scope, $stateParams){
                $scope.title = 'ATM Tips';
                $scope.info = 'There are daily and per transaction limits for cash withdrawals at ATMs on your Akimbo Card account. Akimbo will not permit withdraws that exceed these limits. If you are declined at an ATM, we recommend trying again with a smaller withdrawal amount.\n\nATM Withdrawal Limits:\n$705 per day\n\nNote: These limits include any fee charged by the ATM.';
              }
            },
            'footer@member.home.profile/atm': {
              templateUrl: 'app/views/member/shared/overlay/footer.html',
              controller: function($scope){
                $scope.close = true;
              }
            }
          }
        })

        // subcard search for retrieve funds
        .state('member.home.subaccount/search', {
          url: 'search',
          data: {roles: ['authenticated', 'primary'], overlay: true},
          abstract: true,
          views: {
            'overlay@': {
              templateUrl: 'app/views/member/shared/overlay/layout.html',
              controller: 'subaccountSearchCtrl'
            }
          }
        })
        .state('member.home.subaccount/search.step1', {
          url: '',
          data: {roles: ['authenticated', 'primary'], overlay: true},
          views: {
            'header@member.home.subaccount/search': {
              templateUrl: 'app/views/member/shared/overlay/header-default.html',
              controller: function ($scope){
                $scope.title = 'Who Are You Retrieving Money From?';
                $scope.info = 'Select the card below you wish to transfer money from. On the next screen you\'ll enter the amount you wish to transfer to your primary card.';
              }
            },
            'step@member.home.subaccount/search': {
              templateUrl: 'app/views/member/subaccount/retrieve/search.html'
            },
            'footer@member.home.subaccount/search': {
              template: ''
            }
          }
        })


        // Retrieve subaccount funds
        .state('member.home.subaccount/retrieve', {
          url: 'retrieve',
          data: {roles: ['authenticated', 'primary'], overlay: true},
          abstract: true,
          views: {
            'overlay@': {
              templateUrl: 'app/views/member/shared/overlay/layout.html',
              controller: 'retrieveFundsCtrl'
            }
          }
        })
        .state('member.home.subaccount/retrieve.step1', {
          url: '',
          data: {roles: ['authenticated', 'primary'], overlay: true},
          views: {
            'header@member.home.subaccount/retrieve': {
              templateUrl: 'app/views/member/subaccount/retrieve/header-content.html',
              controller: function ($scope){
                $scope.title = 'Here you can transfer funds from your card';
                $scope.info = 'Simply enter the amount and then click next. Funds will be transferred to your ' +
                    $scope.brand.commonProgramName + ' instantly.';
              }
            },
            'step@member.home.subaccount/retrieve': {
              templateUrl: 'app/views/member/subaccount/retrieve/step1.html'
            },
            'side@member.home.subaccount/retrieve': {
              templateUrl: 'app/views/member/shared/overlay/side-options.html',
              controller: function ($scope){
                $scope.showAddMessage = true;

                $scope.addMessage = function(message){
                  $scope.formData.Note = message;
                  $scope.showAddMessageOption = false;
                };
              }
            },
            'footer@member.home.subaccount/retrieve': {
              templateUrl: 'app/views/member/shared/overlay/footer.html',
              controller: function($scope){
                $scope.mainBtn = {
                  attemptSubmission: true,
                  title: 'NEXT'
                };
                $scope.cancel = true;
              }
            }
          }
        })
        .state('member.home.subaccount/retrieve.step2', {
          url: '',
          data: {roles: ['authenticated', 'full'], overlay: true},
          views: {
            'header@member.home.subaccount/retrieve': {
              templateUrl: 'app/views/member/subaccount/retrieve/header-content.html',
              controller: function ($scope){
                $scope.title = 'Ok, we\'re ready to send';
                $scope.info = 'Review your transfer below and click send when you\'re ready';
              }
            },
            'step@member.home.subaccount/retrieve': {
              templateUrl: 'app/views/member/subaccount/retrieve/step2.html'
            },
            'footer@member.home.subaccount/retrieve': {
              templateUrl: 'app/views/member/shared/overlay/footer.html',
              controller: function ($scope){
                $scope.mainBtn = {
                  processForm: true,
                  title: 'SEND'
                };
                $scope.btns = [{
                  title: 'EDIT',
                  state: 'member.home.subaccount/retrieve.step2'
                }];
                $scope.cancel = true;
              }
            }
          }
        })
        .state('member.home.subaccount/retrieve.step3', {
          url: '',
          data: {roles: ['authenticated', 'full'], overlay: true},
          views: {
            'header@member.home.subaccount/retrieve': {
              templateUrl: 'app/views/member/subaccount/retrieve/header-content.html',
              controller: function ($scope){
                $scope.title = 'Your money has been sent!';
                $scope.info = 'Now wasn\'t that easy?';
              }
            },
            'step@member.home.subaccount/retrieve': {
              templateUrl: 'app/views/member/subaccount/retrieve/step3.html'
            },
            'footer@member.home.subaccount/retrieve': {
              templateUrl: 'app/views/member/shared/overlay/footer.html',
              controller: function ($scope){
                $scope.close = true;
              }
            }
          }
        })

        .state('member.home.subaccount/load', {
          url: 'loadsub',
          data: {roles: ['authenticated', 'primary'], overlay: true},
          abstract: true,
          views: {
            'overlay@': {
              templateUrl: 'app/views/member/shared/overlay/layout.html',
              controller: 'loadSubCtrl'
            }
          }
        })
        .state('member.home.subaccount/load.step1', {
          url: '',
          data: {roles: ['authenticated', 'primary'], overlay: true},
          views: {
            'header@member.home.subaccount/load': {
              templateUrl: 'app/views/member/subaccount/load/header-content.html',
              controller: function ($scope){
                $scope.title = 'Here you can load funds to your card';
                $scope.info = 'Simply enter the amount and then click next. Funds will be transferred to your ' +
                    $scope.transferFrom.FirstName + ' ' + $scope.transferFrom.LastName + ' Card instantly.';
              }
            },
            'step@member.home.subaccount/load': {
              templateUrl: 'app/views/member/send/transfer/step2.html'
            },
            'side@member.home.subaccount/load': {
              templateUrl: 'app/views/member/shared/overlay/side-options.html',
              controller: function ($scope){
                $scope.showAddMessage = true;

                $scope.addMessage = function(message){
                  $scope.formData.Note = message;
                  $scope.showAddMessageOption = false;
                };
              }
            },
            'footer@member.home.subaccount/load': {
              templateUrl: 'app/views/member/shared/overlay/footer.html',
              controller: function($scope){
                $scope.mainBtn = {
                  attemptSubmission: true,
                  title: 'NEXT'
                };
                $scope.cancel = true;
              }
            }
          }
        })
        .state('member.home.subaccount/load.step2', {
          url: '',
          data: {roles: ['authenticated', 'primary'], overlay: true},
          views: {
            'header@member.home.subaccount/load': {
              templateUrl: 'app/views/member/subaccount/load/header-content.html',
              controller: function ($scope){
                $scope.title = 'Ok, we\'re ready to send';
                $scope.info = 'Review your transfer below and click send when you\'re ready';
              }
            },
            'step@member.home.subaccount/load': {
              templateUrl: 'app/views/member/send/transfer/step3.html'
            },
            'footer@member.home.subaccount/load': {
              templateUrl: 'app/views/member/shared/overlay/footer.html',
              controller: function ($scope){
                $scope.mainBtn = {
                  processForm: true,
                  title: 'SEND'
                };
                $scope.btns = [{
                  title: 'EDIT',
                  state: 'member.home.subaccount/load.step1'
                }];
                $scope.cancel = true;
              }
            }
          }
        })
        .state('member.home.subaccount/load.step3', {
          url: '',
          data: {roles: ['authenticated', 'primary'], overlay: true},
          views: {
            'header@member.home.subaccount/load': {
              templateUrl: 'app/views/member/subaccount/load/header-content.html'
            },
            'step@member.home.subaccount/load': {
              templateUrl: 'app/views/member/send/transfer/step4.html'
            },
            'footer@member.home.subaccount/load': {
              templateUrl: 'app/views/member/shared/overlay/footer.html',
              controller: function ($scope){
                $scope.close = true;
              }
            }
          }
        })

        .state('member.home.subaccount/enable', {
          url: 'enable',
          data: {roles: ['authenticated', 'primary'], overlay: true},
          abstract: true,
          views: {
            'overlay@': {
              templateUrl: 'app/views/member/shared/overlay/layout.html',
              controller: 'enableSubCtrl'
            }
          }
        })
        .state('member.home.subaccount/enable.step1', {
          url: '',
          data: {roles: ['authenticated', 'primary'], overlay: true},
          views: {
            'header@member.home.subaccount/enable':{
              templateUrl: 'app/views/member/shared/overlay/header-default.html',
              controller: function($scope) {
                $scope.title = 'Enable Card';
                $scope.info = 'When you\'re ready to enable this card, click enable below.';
              }
            },
            'step@member.home.subaccount/enable': {
              templateUrl: 'app/views/member/subaccount/enable/step1.html'
            },
            'side@member.home.subaccount/enable': {
              templateUrl: 'app/views/member/shared/overlay/side-text.html',
              controller: function ($scope){
                $scope.title = 'Did you know?';
                $scope.info = 'This action will enable all transactions including POS purchases. You can disable this card at any time.';
              }
            },
            'footer@member.home.subaccount/enable': {
              templateUrl: 'app/views/member/shared/overlay/footer.html',
              controller: function($scope){
                $scope.mainBtn = {
                  attemptSubmission: true,
                  title: 'ENABLE'
                };
                $scope.cancel = true;
              }
            }
          }
        })
        .state('member.home.subaccount/enable.confirmation', {
          url: '',
          data: {roles: ['authenticated', 'primary'], overlay: true},
          views: {
            'header@member.home.subaccount/enable':{
              templateUrl: 'app/views/member/shared/overlay/header-default.html',
              controller: function($scope) {
                $scope.title = 'Your card has been enabled';
                $scope.info = 'Remember, you can easily disable later at any time';
              }
            },
            'step@member.home.subaccount/enable': {
              templateUrl: 'app/views/member/subaccount/enable/step1.html'
            },
            'side@member.home.subaccount/enable': {
              templateUrl: 'app/views/member/shared/overlay/side-text.html',
              controller: function ($scope){
                $scope.title = 'Did you know?';
                $scope.info = 'This action will enable all transactions including POS purchases. You can disable this card at any time.';
              }
            },
            'footer@member.home.subaccount/enable': {
              templateUrl: 'app/views/member/shared/overlay/footer.html',
              controller: function($scope){
                $scope.close = true;
              }
            }
          }
        })

        .state('member.home.subaccount/disable', {
          url: 'disable',
          data: {roles: ['authenticated', 'primary'], overlay: true},
          abstract: true,
          views: {
            'overlay@': {
              templateUrl: 'app/views/member/shared/overlay/layout.html',
              controller: 'disableSubCtrl'
            }
          }
        })
        .state('member.home.subaccount/disable.step1', {
          url: '',
          data: {roles: ['authenticated', 'primary'], overlay: true},
          views: {
            'header@member.home.subaccount/disable':{
              templateUrl: 'app/views/member/shared/overlay/header-default.html',
              controller: function($scope) {
                $scope.title = 'Disable Card';
                $scope.info = 'When you\'re ready to disable this card, click disable below.';
              }
            },
            'step@member.home.subaccount/disable': {
              templateUrl: 'app/views/member/subaccount/enable/step1.html'
            },
            'side@member.home.subaccount/disable': {
              templateUrl: 'app/views/member/shared/overlay/side-text.html',
              controller: function ($scope){
                $scope.title = 'Did you know?';
                $scope.info = 'This action will disable all transactions including POS purchases. You can re-activate this card at any time.';
              }
            },
            'footer@member.home.subaccount/disable': {
              templateUrl: 'app/views/member/shared/overlay/footer.html',
              controller: function($scope){
                $scope.mainBtn = {
                  attemptSubmission: true,
                  title: 'DISABLE'
                };
                $scope.cancel = true;
              }
            }
          }
        })
        .state('member.home.subaccount/disable.confirmation', {
          url: '',
          data: {roles: ['authenticated', 'primary'], overlay: true},
          views: {
            'header@member.home.subaccount/disable':{
              templateUrl: 'app/views/member/shared/overlay/header-default.html',
              controller: function($scope) {
                $scope.title = 'Your card has been disabled';
                $scope.info = 'Remember, you can easily enable later at any time';
              }
            },
            'step@member.home.subaccount/disable': {
              templateUrl: 'app/views/member/subaccount/enable/step1.html'
            },
            'side@member.home.subaccount/disable': {
              templateUrl: 'app/views/member/shared/overlay/side-text.html',
              controller: function ($scope){
                $scope.title = 'Did you know?';
                $scope.info = 'This action will disable all transactions including POS purchases. You can re-activate this card at any time.';
              }
            },
            'footer@member.home.subaccount/disable': {
              templateUrl: 'app/views/member/shared/overlay/footer.html',
              controller: function($scope){
                $scope.close = true;
              }
            }
          }
        })
        .state('member.home.subaccount/close', {
          url: 'close',
          data: {roles: ['authenticated', 'primary'], overlay: true},
          abstract: true,
          views: {
            'overlay@': {
              templateUrl: 'app/views/member/shared/overlay/layout.html',
              controller: 'closeSubCtrl'
            }
          }
        })
        .state('member.home.subaccount/close.step1', {
          url: '',
          data: {roles: ['authenticated', 'primary'], overlay: true},
          views: {
            'header@member.home.subaccount/close':{
              templateUrl: 'app/views/member/shared/overlay/header-default.html',
              controller: function($scope) {
                $scope.title = 'Close Card';
                $scope.info = 'When you\'re ready to close this card, click close below.';
              }
            },
            'step@member.home.subaccount/close': {
              templateUrl: 'app/views/member/subaccount/close/step1.html'
            },
            'side@member.home.subaccount/close': {
              templateUrl: 'app/views/member/shared/overlay/side-text.html',
              controller: function ($scope){
                $scope.title = '';
                $scope.info = '';
              }
            },
            'footer@member.home.subaccount/close': {
              templateUrl: 'app/views/member/shared/overlay/footer.html',
              controller: function($scope){
                $scope.mainBtn = {
                  attemptSubmission: true,
                  title: 'CLOSE CARD'
                };
                $scope.cancel = true;
              }
            }
          }
        })
        .state('member.home.subaccount/close.confirmation', {
          url: '',
          data: {roles: ['authenticated', 'primary'], overlay: true},
          views: {
            'header@member.home.subaccount/close':{
              templateUrl: 'app/views/member/shared/overlay/header-default.html',
              controller: function($scope) {
                $scope.title = 'Your card has been closed';
                $scope.info = 'This card will now be removed.';
              }
            },
            'step@member.home.subaccount/close': {
              templateUrl: 'app/views/member/subaccount/enable/step1.html'
            },
            'side@member.home.subaccount/close': {
              templateUrl: 'app/views/member/shared/overlay/side-text.html',
              controller: function ($scope){
                $scope.title = '';
                $scope.info = '';
              }
            },
            'footer@member.home.subaccount/close': {
              templateUrl: 'app/views/member/shared/overlay/footer.html',
              controller: function($scope){
                $scope.close = true;
              }
            }
          }
        })
        // add to wallet
        .state('member.home.profile/wallet', {
          url: 'wallet',
          data: {roles: ['authenticated', 'full'], overlay: true},
          abstract: true,
          views: {
            'overlay@': {
              templateUrl: 'app/views/member/shared/overlay/layout.html',
              controller: 'walletCtrl'
            }
          }
        })
        .state('member.home.profile/wallet.step1', {
          url: '',
          data: {roles: ['authenticated', 'virtual'], overlay: true},
          views: {
            'header@member.home.profile/wallet': {
              templateUrl: 'app/views/member/shared/overlay/header-default.html',
              controller: function ($scope){
                $scope.title = 'Select Your Device';
                $scope.info = 'To add your virtual card to your mobile wallet, please first select your platform.';
              }
            },
            'step@member.home.profile/wallet': {
              templateUrl: 'app/views/member/wallet/step1.html'
            },
            'footer@member.home.profile/wallet': {
              templateUrl: 'app/views/member/shared/overlay/footer.html',
              controller: function ($scope, $state) {
                $scope.cancel = true;
              }
            }
          }
        })
        .state('member.home.profile/wallet.apple', {
          url: '',
          data: {roles: ['authenticated', 'virtual'], overlay: true},
          views: {
            'header@member.home.profile/wallet': {
              templateUrl: 'app/views/member/shared/overlay/header-default.html',
              controller: function ($scope){
                $scope.title = 'Add your virtual card to Apple Pay';
                $scope.info = 'Use the information below to easily add your virtual card to Apple Pay. Scroll down for step by step instructions.';
              }
            },
            'step@member.home.profile/wallet': {
              templateUrl: 'app/views/member/wallet/apple.html'
            },
            'footer@member.home.profile/wallet': {
              templateUrl: 'app/views/member/shared/overlay/footer.html',
              controller: function ($scope, $state) {
                $scope.btns = [{
                  title: 'BACK',
                  state: 'member.home.profile/wallet.step1'
                }];
                $scope.cancel = true;
              }
            }
          }
        })
        .state('member.home.profile/wallet.google', {
          url: '',
          data: {roles: ['authenticated', 'virtual'], overlay: true},
          views: {
            'header@member.home.profile/wallet': {
              templateUrl: 'app/views/member/shared/overlay/header-default.html',
              controller: function ($scope){
                $scope.title = 'Add your virtual card to Google Pay';
                $scope.info = 'Use the information below to easily add your virtual card to Google Pay. Scroll down for step by step instructions.';
              }
            },
            'step@member.home.profile/wallet': {
              templateUrl: 'app/views/member/wallet/google.html'
            },
            'footer@member.home.profile/wallet': {
              templateUrl: 'app/views/member/shared/overlay/footer.html',
              controller: function ($scope, $state) {
                $scope.btns = [{
                  title: 'BACK',
                  state: 'member.home.profile/wallet.step1'
                }];
                $scope.cancel = true;
              }
            }
          }
        })
        .state('member.home.profile/wallet.samsung', {
          url: '',
          data: {roles: ['authenticated', 'virtual'], overlay: true},
          views: {
            'header@member.home.profile/wallet': {
              templateUrl: 'app/views/member/shared/overlay/header-default.html',
              controller: function ($scope){
                $scope.title = 'Add your virtual card to Samsung Pay';
                $scope.info = 'Use the information below to easily add your virtual card to Samsung Pay. Scroll down for step by step instructions.';
              }
            },
            'step@member.home.profile/wallet': {
              templateUrl: 'app/views/member/wallet/samsung.html'
            },
            'footer@member.home.profile/wallet': {
              templateUrl: 'app/views/member/shared/overlay/footer.html',
              controller: function ($scope, $state) {
                $scope.btns = [{
                  title: 'BACK',
                  state: 'member.home.profile/wallet.step1'
                }];
                $scope.cancel = true;
              }
            }
          }
        })

        // view sub-vcard number
        .state('member.home.profile/virtual', {
          url: 'virtual',
          data: {roles: ['authenticated', 'primary'], overlay: true},
          abstract: true,
          views: {
            'overlay@': {
              templateUrl: 'app/views/member/shared/overlay/layout.html',
              controller: 'virtualCtrl'
            }
          }
        })
        .state('member.home.profile/virtual.step1', {
          url: '',
          data: {roles: ['authenticated', 'virtual'], overlay: true},
          views: {
            'header@member.home.profile/virtual': {
              templateUrl: 'app/views/member/shared/overlay/header-default.html',
              controller: function ($scope){
                $scope.title = 'Learn how to use your virtual card';
                $scope.info = 'Use your virtual ' + $scope.brand.fullProgramName + ' for online purchases.';
              }
            },
            'step@member.home.profile/virtual': {
              templateUrl: 'app/views/member/virtual/step1.html'
            },
            'side@member.home.profile/virtual': {
              templateUrl: 'app/views/member/virtual/side-options.html',
              controller: function ($scope){
                $scope.copySuccess = false;
                $scope.copyError = false;
                $scope.info = $scope.brand.programContactPhone + '\n7:00am-7:00pm CT, Monday-Friday\n' + $scope.brand.programContactEmail;
              }
            },
            'footer@member.home.profile/virtual': {
              templateUrl: 'app/views/member/shared/overlay/footer.html',
              controller: function($scope){
                $scope.mainBtn = {};
                $scope.close = true;
              }
            }
          }
        })

        // Withdraw ACH
        .state('member.home.ach', {
          url: 'ach',
          data: {roles: ['authenticated', 'full'], overlay: true},
          abstract: true,
          views: {
            'overlay@': {
              templateUrl: 'app/views/member/shared/overlay/layout.html',
              controller: 'achCtrl'
            }
          }
        })
        .state('member.home.ach.step1', {
          url: '',
          data: {roles: ['authenticated', 'full'], overlay: true},
          views: {
            'header@member.home.ach': {
              templateUrl: 'app/views/member/shared/overlay/header-default.html',
              controller: function ($scope){
                $scope.title = 'Withdraw to your bank account';
                $scope.info = '';
              }
            },
            'step@member.home.ach': {
              templateUrl: 'app/views/member/ach/step1.html'
            },
            'side@member.home.ach': {
              templateUrl: 'app/views/member/ach/side-options.html',
              controller: function ($scope){
                $scope.info = $scope.brand.programContactPhone + '\n7:00am-7:00pm CT, Monday-Friday\n' + $scope.brand.programContactEmail;
              }
            },
            'footer@member.home.ach': {
              templateUrl: 'app/views/member/shared/overlay/footer.html',
              controller: function($scope){
                $scope.mainBtn = {
                  attemptSubmission: true,
                  title: 'NEXT'
                };
                $scope.close = true;
              }
            }
          }
        })
        .state('member.home.ach.step2', {
          url: '',
          data: {roles: ['authenticated', 'full'], overlay: true},
          views: {
            'header@member.home.ach': {
              templateUrl: 'app/views/member/ach/header-content.html',
              controller: function ($scope){
                $scope.title = 'Ok, we\'re ready to send';
                $scope.info = 'Review your transfer below and click send when you\'re ready';
              }
            },
            'step@member.home.ach': {
              templateUrl: 'app/views/member/ach/step2.html'
            },
            'footer@member.home.ach': {
              templateUrl: 'app/views/member/shared/overlay/footer.html',
              controller: function ($scope){
                $scope.mainBtn = {
                  processForm: true,
                  title: 'SEND'
                };
                $scope.close = true;
              }
            }
          }
        })

        // Send Check
        .state('member.home.send-check', {
          url: 'send-check',
          data: {roles: ['authenticated', 'full'], overlay: true},
          abstract: true,
          views: {
            'overlay@': {
              templateUrl: 'app/views/member/shared/overlay/layout.html',
              controller: 'sendCheckCtrl'
            }
          }
        })
        .state('member.home.send-check.step1', {
          url: '',
          data: {roles: ['authenticated', 'full'], overlay: true},
          views: {
            'header@member.home.send-check': {
              templateUrl: 'app/views/member/shared/overlay/header-default.html',
              controller: function ($scope){
                $scope.title = 'Enter the address of the recipient.';
                $scope.info = '';
              }
            },
            'step@member.home.send-check': {
              templateUrl: 'app/views/member/send-check/step1.html'
            },
            'side@member.home.send-check': {
              templateUrl: 'app/views/member/send-check/side-options.html',
              controller: function ($scope){
                $scope.info = $scope.brand.programContactPhone + '\n7:00am-7:00pm CT, Monday-Friday\n' + $scope.brand.programContactEmail;
              }
            },
            'footer@member.home.send-check': {
              templateUrl: 'app/views/member/shared/overlay/footer.html',
              controller: function($scope){
                $scope.mainBtn = {
                  attemptSubmission: true,
                  title: 'NEXT'
                };
                $scope.cancel = true;
              }
            }
          }
        })
        .state('member.home.send-check.step2', {
          url: '',
          data: {roles: ['authenticated', 'full'], overlay: true},
          views: {
            'header@member.home.send-check': {
              templateUrl: 'app/views/member/shared/overlay/header-default.html',
              controller: function ($scope){
                $scope.title = 'Send Check';
                $scope.info = '';
              }
            },
            'step@member.home.send-check': {
              templateUrl: 'app/views/member/send-check/step2.html'
            },
            'side@member.home.send-check': {
              templateUrl: 'app/views/member/send-check/side-options.html',
              controller: function ($scope){
                $scope.info = $scope.brand.programContactPhone + '\n7:00am-7:00pm CT, Monday-Friday\n' + $scope.brand.programContactEmail;
              }
            },
            'footer@member.home.send-check': {
              templateUrl: 'app/views/member/shared/overlay/footer.html',
              controller: function($scope){
                $scope.mainBtn = {
                  processForm: true,
                  title: 'SEND'
                };
                // $scope.close = true;
                $scope.cancel = true;
                $scope.btns = [{
                  title: 'EDIT',
                  state: 'member.home.send-check.step1'
                }];
              }
            }
          }
        })
        .state('member.home.send-check.step3', {
          url: '',
          data: {roles: ['authenticated', 'full'], overlay: true},
          views: {
            'header@member.home.send-check': {
              templateUrl: 'app/views/member/shared/overlay/header-default.html',
              controller: function ($scope){
                $scope.title = 'Your check has been sent!';
                $scope.info = 'Now wasn\'t that easy?';
              }
            },
            'step@member.home.send-check': {
              templateUrl: 'app/views/member/send-check/step3.html'
            },
            'footer@member.home.send-check': {
              templateUrl: 'app/views/member/shared/overlay/footer.html',
              controller: function ($scope){
                $scope.close = true;
              }
            }
          }
        })

        // Instant Bank Withdrawal
        .state('member.home.debit-card-withdrawal', {
          url: 'debit-card-withdrawal',
          data: {roles: ['authenticated', 'full'], overlay: true},
          abstract: true,
          views: {
            'overlay@': {
              templateUrl: 'app/views/member/shared/overlay/layout.html',
              controller: 'debitWithdrawCtrl'
            }
          }
        })
        .state('member.home.debit-card-withdrawal.step1', {
          url: '',
          data: {roles: ['authenticated', 'full'], overlay: true},
          views: {
            'header@member.home.debit-card-withdrawal': {
              templateUrl: 'app/views/member/shared/overlay/header-default.html',
              controller: function ($scope){
                $scope.title = 'Enter the 3rd-party card number and information.';
                $scope.info = 'Here you can transfer money from your ' + $scope.brand.programName + ' Card to a 3rd-party debit card. Simply enter an amount and the receiving card information, and then click next.';
              }
            },
            'step@member.home.debit-card-withdrawal': {
              templateUrl: 'app/views/member/debit-card-withdrawal/step1.html'
            },
            'side@member.home.debit-card-withdrawal': {
              templateUrl: 'app/views/member/debit-card-withdrawal/side-options.html',
              controller: function ($scope){
                $scope.info = $scope.brand.programContactPhone + '\n7:00am-7:00pm CT, Monday-Friday\n' + $scope.brand.programContactEmail;
              }
            },
            'footer@member.home.debit-card-withdrawal': {
              templateUrl: 'app/views/member/shared/overlay/footer.html',
              controller: function($scope){
                $scope.mainBtn = {
                  attemptSubmission: true,
                  title: 'NEXT'
                };
                $scope.cancel = true;
              }
            }
          }
        })
        .state('member.home.debit-card-withdrawal.step2', {
          url: '',
          data: {roles: ['authenticated', 'full'], overlay: true},
          views: {
            'header@member.home.debit-card-withdrawal': {
              templateUrl: 'app/views/member/shared/overlay/header-default.html',
              controller: function ($scope){
                $scope.title = 'Instant Bank Withdrawal';
                $scope.info = 'Review your withdrawal below and click withdraw when you\'re ready';
              }
            },
            'step@member.home.debit-card-withdrawal': {
              templateUrl: 'app/views/member/debit-card-withdrawal/step2.html'
            },
            'side@member.home.debit-card-withdrawal': {
              templateUrl: 'app/views/member/debit-card-withdrawal/side-options.html',
              controller: function ($scope){
                $scope.info = $scope.brand.programContactPhone + '\n7:00am-7:00pm CT, Monday-Friday\n' + $scope.brand.programContactEmail;
              }
            },
            'footer@member.home.debit-card-withdrawal': {
              templateUrl: 'app/views/member/shared/overlay/footer.html',
              controller: function($scope){
                $scope.mainBtn = {
                  processForm: true,
                  title: 'WITHDRAW'
                };
                // $scope.close = true;
                $scope.cancel = true;
                $scope.btns = [{
                  title: 'EDIT',
                  state: 'member.home.debit-card-withdrawal.step1'
                }];
              }
            }
          }
        })
        .state('member.home.debit-card-withdrawal.step3', {
          url: '',
          data: {roles: ['authenticated', 'full'], overlay: true},
          views: {
            'header@member.home.debit-card-withdrawal': {
              templateUrl: 'app/views/member/shared/overlay/header-default.html',
              controller: function ($scope){
                $scope.title = 'Your funds have been transferred!';
                $scope.info = 'Please note that these funds may take several minutes to appear in your bank account.';
              }
            },
            'step@member.home.debit-card-withdrawal': {
              templateUrl: 'app/views/member/debit-card-withdrawal/step3.html'
            },
            'footer@member.home.debit-card-withdrawal': {
              templateUrl: 'app/views/member/shared/overlay/footer.html',
              controller: function ($scope){
                $scope.close = true;
              }
            }
          }
        })

        // Paypal
        .state('member.home.paypal', {
          url: 'paypal',
          data: {roles: ['authenticated', 'full'], overlay: true},
          abstract: true,
          views: {
            'overlay@': {
              templateUrl: 'app/views/member/paypal/layout.html',
              controller: 'paypalCtrl'
            }
          }
        })
        .state('member.home.paypal.step1', {
          url: '',
          data: {roles: ['authenticated', 'full'], overlay: true},
          views: {
            'header@member.home.paypal': {
              templateUrl: 'app/views/member/shared/overlay/header-default.html',
              controller: function ($scope){
                $scope.title = 'Send money from your Akimbo Card to PayPal';
                $scope.info = 'Here you can send money from your Akimbo Card to a PayPal account. Simply enter the PayPal account information and an amount, and then click next.';
              }
            },
            'step@member.home.paypal': {
              templateUrl: 'app/views/member/paypal/step1.html'
            },
            'side@member.home.paypal': {
              templateUrl: 'app/views/member/paypal/side-options.html',
              controller: function ($scope){
                $scope.info = $scope.brand.programContactPhone + '\n7:00am-7:00pm CT, Monday-Friday\n' + $scope.brand.programContactEmail;
              }
            },
            'footer@member.home.paypal': {
              templateUrl: 'app/views/member/shared/overlay/footer.html',
              controller: function($scope){
                $scope.mainBtn = {
                  attemptSubmission: true,
                  title: 'NEXT'
                };
                $scope.cancel = true;
              }
            }
          }
        })
        .state('member.home.paypal.step2', {
          url: '',
          data: {roles: ['authenticated', 'full'], overlay: true},
          views: {
            'header@member.home.paypal': {
              templateUrl: 'app/views/member/shared/overlay/header-default.html',
              controller: function ($scope){
                $scope.title = 'PayPal';
                $scope.info = 'Review your information';
              }
            },
            'step@member.home.paypal': {
              templateUrl: 'app/views/member/paypal/step2.html'
            },
            'side@member.home.paypal': {
              templateUrl: 'app/views/member/paypal/side-options.html',
              controller: function ($scope){
                $scope.info = $scope.brand.programContactPhone + '\n7:00am-7:00pm CT, Monday-Friday\n' + $scope.brand.programContactEmail;
              }
            },
            'footer@member.home.paypal': {
              templateUrl: 'app/views/member/shared/overlay/footer.html',
              controller: function($scope){
                $scope.mainBtn = {
                  processForm: true,
                  title: 'SEND'
                };
                $scope.cancel = true;
                $scope.btns = [{
                  title: 'EDIT',
                  state: 'member.home.paypal.step1'
                }];
              }
            }
          }
        })
        .state('member.home.paypal.step3', {
          url: '',
          data: {roles: ['authenticated', 'full'], overlay: true},
          views: {
            'header@member.home.paypal': {
              templateUrl: 'app/views/member/shared/overlay/header-default.html',
              controller: function ($scope){
                $scope.title = 'Your money has been sent to PayPal!';
                $scope.info = 'Please note that these funds may take several minutes to appear in your Paypal account.';
              }
            },
            'step@member.home.paypal': {
              templateUrl: 'app/views/member/paypal/step3.html'
            },
            'footer@member.home.paypal': {
              templateUrl: 'app/views/member/shared/overlay/footer.html',
              controller: function ($scope){
                $scope.close = true;
              }
            }
          }
        })

        // Venmo
        .state('member.home.venmo', {
          url: 'venmo',
          data: {roles: ['authenticated', 'full'], overlay: true},
          abstract: true,
          views: {
            'overlay@': {
              templateUrl: 'app/views/member/venmo/layout.html',
              controller: 'venmoCtrl'
            }
          }
        })
        .state('member.home.venmo.step1', {
          url: '',
          data: {roles: ['authenticated', 'full'], overlay: true},
          views: {
            'header@member.home.venmo': {
              templateUrl: 'app/views/member/shared/overlay/header-default.html',
              controller: function ($scope){
                $scope.title = 'Send money from your Akimbo Card to Venmo';
                $scope.info = 'Here you can send money from your Akimbo Card to a Venmo account. Simply enter the Venmo account information and an amount, and then click next.';
              }
            },
            'step@member.home.venmo': {
              templateUrl: 'app/views/member/venmo/step1.html'
            },
            'side@member.home.venmo': {
              templateUrl: 'app/views/member/venmo/side-options.html',
              controller: function ($scope){
                $scope.info = $scope.brand.programContactPhone + '\n7:00am-7:00pm CT, Monday-Friday\n' + $scope.brand.programContactEmail;
              }
            },
            'footer@member.home.venmo': {
              templateUrl: 'app/views/member/shared/overlay/footer.html',
              controller: function($scope){
                $scope.mainBtn = {
                  attemptSubmission: true,
                  title: 'NEXT'
                };
                $scope.cancel = true;
              }
            }
          }
        })
        .state('member.home.venmo.step2', {
          url: '',
          data: {roles: ['authenticated', 'full'], overlay: true},
          views: {
            'header@member.home.venmo': {
              templateUrl: 'app/views/member/shared/overlay/header-default.html',
              controller: function ($scope){
                $scope.title = 'Venmo';
                $scope.info = 'Review your information';
              }
            },
            'step@member.home.venmo': {
              templateUrl: 'app/views/member/venmo/step2.html'
            },
            'side@member.home.venmo': {
              templateUrl: 'app/views/member/venmo/side-options.html',
              controller: function ($scope){
                $scope.info = $scope.brand.programContactPhone + '\n7:00am-7:00pm CT, Monday-Friday\n' + $scope.brand.programContactEmail;
              }
            },
            'footer@member.home.venmo': {
              templateUrl: 'app/views/member/shared/overlay/footer.html',
              controller: function($scope){
                $scope.mainBtn = {
                  processForm: true,
                  title: 'SEND'
                };
                $scope.cancel = true;
                $scope.btns = [{
                  title: 'EDIT',
                  state: 'member.home.venmo.step1'
                }];
              }
            }
          }
        })
        .state('member.home.venmo.step3', {
          url: '',
          data: {roles: ['authenticated', 'full'], overlay: true},
          views: {
            'header@member.home.venmo': {
              templateUrl: 'app/views/member/shared/overlay/header-default.html',
              controller: function ($scope){
                $scope.title = 'Your money has been sent to Venmo!';
                $scope.info = 'Please note that these funds may take several minutes to appear in your Venmo account.';
              }
            },
            'step@member.home.venmo': {
              templateUrl: 'app/views/member/venmo/step3.html'
            },
            'footer@member.home.venmo': {
              templateUrl: 'app/views/member/shared/overlay/footer.html',
              controller: function ($scope){
                $scope.close = true;
              }
            }
          }
        })

        // Direct Deposit
        .state('member.home.directdeposit', {
          url: 'directdeposit',
          data: {roles: ['authenticated', 'primary'], overlay: true},
          abstract: true,
          views: {
            'overlay@': {
              templateUrl: 'app/views/member/directdeposit/layout.html',
              controller: 'directDepositCtrl'
            }
          }
        })
        .state('member.home.directdeposit.step1', {
          url: '',
          data: {roles: ['authenticated', 'primary'], overlay: true},
          views: {
            'header@member.home.directdeposit': {
              templateUrl: 'app/views/member/shared/overlay/header-default.html',
              controller: function ($scope){
                $scope.title = 'Get started with direct deposit';
                $scope.info = 'Direct deposit is the easiest way to load your card regularly. Simply print our direct deposit ' +
                    'form and take it to your employer. If you don\'t have access to a printer, copy down the information below ' +
                    'and tell your employer the portion of your check you would like to load on your ' + $scope.brand.programName + ' card.';
              }
            },
            'step@member.home.directdeposit': {
              templateUrl: 'app/views/member/directdeposit/step1.html'
            },
            'side@member.home.directdeposit': {
              templateUrl: 'app/views/member/directdeposit/side-text.html',
              controller: function ($scope){
                $scope.title = 'Did you know?';
                $scope.info = 'Your direct deposit account information can also be used to send money to your ' +
                    $scope.brand.commonProgramName + ' from your bank account website or from PayPal.';
              }
            },
            'footer@member.home.directdeposit': {
              templateUrl: 'app/views/member/shared/overlay/footer.html',
              controller: function($scope){
                $scope.mainBtn = {};
                $scope.showCloseOrRedirect = true;
              }
            }
          }
        })

        // Corporate Expense Deposit
        .state('member.home.corpdeposit', {
          url: 'corpdeposit',
          data: {roles: ['authenticated', 'primary'], overlay: true},
          abstract: true,
          views: {
            'overlay@': {
              templateUrl: 'app/views/member/corpdeposit/layout.html',
              controller: 'corpDepositCtrl'
            }
          }
        })
        .state('member.home.corpdeposit.step1', {
          url: '',
          data: {roles: ['authenticated', 'primary'], overlay: true},
          views: {
            'header@member.home.corpdeposit': {
              templateUrl: 'app/views/member/shared/overlay/header-default.html',
              controller: function ($scope){
                $scope.title = 'How to deposit by ACH or Wire Transfer';
                $scope.info = 'You can make deposits to your Akimbo Commercial account by ACH or wire transfer. Please find the account and routing numbers and instructions below.';
              }
            },
            'step@member.home.corpdeposit': {
              templateUrl: 'app/views/member/corpdeposit/step1.html'
            },
            'side@member.home.corpdeposit': {
              templateUrl: 'app/views/member/corpdeposit/side-text.html',
              controller: function ($scope){
                $scope.title = 'Important Warning';
                $scope.info = 'Do not send a wire transfer to the account designated for ACH transfers or it will be returned!';
                $scope.printDirectDeposit = function(){
                  window.print();
                };
              }
            },
            'footer@member.home.corpdeposit': {
              templateUrl: 'app/views/member/shared/overlay/footer.html',
              controller: function($scope){
                $scope.mainBtn = {};
                $scope.showCloseOrRedirect = true;
              }
            }
          }
        })

        // Virtual Card information
        .state('member.home.virtual', {
          url: 'virtual',
          data: {roles: ['authenticated', 'primary'], overlay: true},
          abstract: true,
          views: {
            'overlay@': {
              templateUrl: 'app/views/member/shared/overlay/layout.html',
              controller: 'virtualCtrl'
            }
          }
        })
        .state('member.home.virtual.step1', {
          url: '',
          data: {roles: ['authenticated', 'virtual'], overlay: true},
          views: {
            'header@member.home.virtual': {
              templateUrl: 'app/views/member/shared/overlay/header-default.html',
              controller: function ($scope){
                $scope.title = 'View Virtual Card';
                $scope.info = 'Use your virtual ' + $scope.brand.fullGiftProgramName + ' for online purchases.';
              }
            },
            'step@member.home.virtual': {
              templateUrl: 'app/views/member/virtual/step1.html'
            },
            'side@member.home.virtual': {
              templateUrl: 'app/views/member/shared/overlay/side-text.html',
              controller: function ($scope){
                $scope.info = $scope.brand.programContactPhone + '\n7:00am-7:00pm CT, Monday-Friday\n' + $scope.brand.programContactEmail;
              }
            },
            'footer@member.home.virtual': {
              templateUrl: 'app/views/member/shared/overlay/footer.html',
              controller: function($scope){
                $scope.mainBtn = {};
                $scope.close = true;
              }
            }
          }
        })
        .state('member.home.send-physical-card', {
          url: 'send-physical-card',
          data: {roles: ['authenticated', 'full'], overlay: true},
          abstract: true,
          views: {
            'overlay@': {
              templateUrl: 'app/views/member/shared/overlay/layout.html',
              controller: 'sendPhysicalCardCtrl'
            }
          }
        })
        .state('member.home.send-physical-card.step1', {
          url: '',
          data: {roles: ['authenticated', 'full'], overlay: true},
          views: {
            'header@member.home.send-physical-card': {
              templateUrl: 'app/views/member/shared/overlay/header-default.html',
              controller: function ($scope){
                $scope.title = 'Enter your mailing address';
                $scope.info = 'Please enter the mailing address you would like the card to be shipped to.';
                if($scope.brand.name === 'svm' || $scope.brand.name === 'prosperikey') {
                  $scope.info += ' Please note that your account may be assessed a $3.00 Card Replacement Fee for ordering this physical card.';
                }
              }
            },
            'step@member.home.send-physical-card': {
              templateUrl: 'app/views/member/send-physical-card/step1.html'
            },
            'footer@member.home.send-physical-card': {
              templateUrl: 'app/views/member/shared/overlay/footer.html',
              controller: function($scope){
                $scope.mainBtn = {
                  title: 'SEND',
                  attemptSubmissionAndProcessForm: true,
                };
                $scope.close = true;
              }
            }
          }
        })
        .state('member.home.send-physical-card.confirmation', {
          url: '',
          data: {roles: ['authenticated', 'full'], overlay: true},
          views: {
            'header@member.home.send-physical-card': {
              templateUrl: 'app/views/member/shared/overlay/header-default.html',
              controller: function ($scope){
                $scope.title = 'Your card will ship soon';
                $scope.info = 'You should receive your card at the address below within 5-7 business days';
              }
            },
            'step@member.home.send-physical-card': {
              templateUrl: 'app/views/member/send-physical-card/confirmation.html',
            },
            'footer@member.home.send-physical-card': {
              templateUrl: 'app/views/member/shared/overlay/footer.html',
              controller: function($scope){
                $scope.mainBtn = {};
                $scope.close = true;
              }
            }
          }
        })

        // RDC Load Routes
        .state('member.home.rdc/load', {
          url: 'rdc/load',
          data: {roles: ['authenticated', 'primary'], overlay: true},
          abstract: true,
          views: {
            'overlay@': {
              templateUrl: 'app/views/member/shared/overlay/layout.html',
              controller: function($scope, OVERLAY){
                $scope.overlay = OVERLAY['member.home.rdc/load'];
                $scope.formData = {};
              }
            }
          }
        })
        .state('member.home.rdc/load.step1', {
          url: '',
          data: {roles: ['authenticated', 'primary'], overlay: true},
          views: {
            'header@member.home.rdc/load': {
              templateUrl: 'app/views/member/shared/overlay/header-default.html',
              controller: function ($scope){
                $scope.title = 'Get started with check loading';
                $scope.info = 'With the Ingo Money app, funds can be loaded onto your ' +
                    $scope.brand.commonProgramName + ' within minutes for a fee* or in 7 days with no fee.';
              }
            },
            'step@member.home.rdc/load': {
              templateUrl: 'app/views/member/rdc/step1.html'
            },
            'side@member.home.rdc/load': {
              templateUrl: 'app/views/member/shared/overlay/side-options.html',
              controller: function($scope){
                $scope.showLoadCheck = true;
              }
            },
            'footer@member.home.rdc/load': {
              templateUrl: 'app/views/member/shared/overlay/footer.html',
              controller: function ($scope){
                $scope.mainBtn = {};
                $scope.close = true;
              }
            }
          }
        })


        // Cash Load Routes
        .state('member.home.cash/load', {
          url: 'cash/load',
          data: {roles: ['authenticated', 'primary'], overlay: true},
          abstract: true,
          views: {
            'overlay@': {
              templateUrl: 'app/views/member/shared/overlay/layout.html',
              controller: function($scope, OVERLAY){
                $scope.overlay = OVERLAY['member.home.cash/load'];
                $scope.formData = {};
              }
            }
          }
        })
        .state('member.home.cash/load.step1', {
          url: '',
          data: {roles: ['authenticated', 'primary'], overlay: true},
          views: {
            'header@member.home.cash/load': {
              templateUrl: 'app/views/member/shared/overlay/header-default.html',
              controller: function ($scope){
                $scope.title = 'Loading cash is easy';
                $scope.info = 'You can load your ' + $scope.brand.commonProgramName + ' by simply visiting participating locations listed below and providing your card on request.';
              }
            },
            'step@member.home.cash/load': {
              templateUrl: 'app/views/member/cashload/step1.html'
            },
            'side@member.home.cash/load': {
              templateUrl: 'app/views/member/shared/overlay/side-options.html',
              controller: function($scope){
                $scope.showCashLoad = true;
              }
            },
            'footer@member.home.cash/load': {
              templateUrl: 'app/views/member/shared/overlay/footer.html',
              controller: function ($scope){
                $scope.mainBtn = {};
                $scope.close = true;
              }
            }
          }
        })

        // Load Block Routes
        .state('member.home.block/load', {
          url: 'issue/load',
          data: {roles: ['authenticated', 'primary'], overlay: true},
          abstract: true,
          views: {
            'overlay@': {
              templateUrl: 'app/views/member/shared/overlay/layout.html',
              controller: function($scope, OVERLAY){
                $scope.overlay = OVERLAY['member.home.block/load'];
                $scope.formData = {};
              }
            }
          }
        })
        .state('member.home.block/load.step1', {
          url: '',
          data: {roles: ['authenticated', 'primary'], overlay: true},
          views: {
            'header@member.home.block/load': {
              templateUrl: 'app/views/member/shared/overlay/header-default.html',
              controller: function ($scope){
                $scope.title = 'Account Alert';
                $scope.info = 'Please read important information regarding your account below.';
              }
            },
            'step@member.home.block/load': {
              templateUrl: 'app/views/member/blockload/step1.html'
            },
            'footer@member.home.block/load': {
              templateUrl: 'app/views/member/shared/overlay/footer.html',
              controller: function ($scope){
                $scope.mainBtn = {};
                $scope.close = true;
              }
            }
          }
        })

        // Fraud Block Routes
        .state('member.home.block/fraud', {
          url: 'issue/account',
          data: {roles: ['authenticated', 'primary'], overlay: true},
          abstract: true,
          views: {
            'overlay@': {
              templateUrl: 'app/views/member/shared/overlay/layout.html',
              controller: function($scope, OVERLAY){
                $scope.overlay = OVERLAY['member.home.block/fraud'];
                $scope.formData = {};
              }
            }
          }
        })
        // Bill Pay Routes
        .state('member.home.billpay', {
          url: 'billpay',
          data: {roles: ['authenticated', 'primary'], overlay: true},
          abstract: true,
          views: {
            'overlay@': {
              templateUrl: 'app/views/member/shared/overlay/layout.html',
              controller: function($scope, OVERLAY){
                $scope.overlay = OVERLAY['member.home.billpay.list'];
                $scope.formData = {};
                $scope.attemptSubmission = function (formData){
                  if(formData.$valid){
                    $state.transitionTo('member.home.billpay.new');
                  } else {
                    $scope.attempted = true;
                  }
                };
              }
            }
          }
        })
        .state('member.home.billpay.list', {
          url: 'list',
          data: {roles: ['authenticated', 'primary'], overlay: true},
          views: {
            'header@member.home.billpay': {
              templateUrl: 'app/views/member/shared/overlay/header-default.html',
              controller: function($scope, OVERLAY){
                $scope.title = 'Send Check';
                $scope.info = 'Send a check by selecting a payee below or add a new payee on the right.';
              }
            },
            'step@member.home.billpay': {
              templateUrl: 'app/views/member/billpay/list.html'
            },
            'side@member.home.billpay': {
              templateUrl: 'app/views/member/shared/overlay/side-options.html',
              controller: function($scope){
                $scope.showPayee = true;
              }
            }
          }
        })
        .state('member.home.billpay.new', {
          url: 'new',
          data: {roles: ['authenticated', 'primary'], overlay: true},
          views: {
            'header@member.home.billpay': {
              templateUrl: 'app/views/member/shared/overlay/header-default.html',
              controller: function($scope, OVERLAY){
                $scope.title = 'Send Check';
                $scope.info = 'Send a check by selecting a payee below or add a new payee on the right.';
              }
            },
            'step@member.home.billpay': {
              templateUrl: 'app/views/member/billpay/new.html',
              resolve: {
                data: function(Session){
                  return Session.getBalance();
                }
              },
              controller: function($scope, data, STATES){
                $scope.balance = data;
                $scope.states = STATES;
              }
            },
            'side@member.home.billpay': {
              templateUrl: 'app/views/member/shared/overlay/side-text.html',
              controller: function ($scope){
                $scope.title = 'Fee Information';
                $scope.info = 'Please note: The maximum amount per paper check is $1,000. ' + $scope.brand.programName + ' is happy to split up the amount into separate checks, however, please be aware that a $0.99 fee will be attached to each check.';
              }
            },
            'footer@member.home.billpay': {
              templateUrl: 'app/views/member/shared/overlay/footer.html',
              controller: function ($scope) {
                $scope.mainBtn = {
                  title: 'NEXT',
                  attemptSubmission: true
                };
                $scope.cancel = true;
              }
            }
          }
        })

        // Limit Routes
        .state('member.home.limits', {
          url: 'limits/list',
          data: {roles: ['authenticated', 'full'], overlay: true},
          abstract: true,
          views: {
            'overlay@': {
              templateUrl: 'app/views/member/shared/overlay/layout.html',
              controller: 'listLimitsCtrl'
            }
          }
        })
        .state('member.home.limits.list', {
          url: '',
          data: {roles: ['authenticated', 'full'], overlay: true},
          views: {
            'header@member.home.limits': {
              templateUrl: 'app/views/member/shared/overlay/header-default.html',
              controller: function($scope, OVERLAY){
                $scope.title = 'Your account restrictions';
                $scope.info = 'Here you can view limits and restrictions associated with this card.';
              }
            },
            'step@member.home.limits': {
              templateUrl: 'app/views/member/limits/list.html'
            },
            'side@member.home.limits': {
              templateUrl: 'app/views/member/shared/overlay/side-text.html',
              controller: function($scope){
                $scope.title = '';
                $scope.info = '';
              }
            }
          }
        })

        // Bank Routes
        .state('member.home.bank/manage', {
          url: 'bank/manage',
          data: {roles: ['authenticated', 'full'], overlay: true},
          abstract: true,
          views: {
            'overlay@': {
              templateUrl: 'app/views/member/shared/overlay/layout.html',
              controller: 'listBankCtrl'
            }
          }
        })
        .state('member.home.bank/manage.list', {
          url: '',
          data: {roles: ['authenticated', 'full'], overlay: true},
          views: {
            'header@member.home.bank/manage': {
              templateUrl: 'app/views/member/shared/overlay/header-default.html',
              controller: function($scope, OVERLAY){
                $scope.title = 'Your linked bank accounts';
                $scope.info = 'Here you can manage your bank accounts. You can remove or view details by clicking on a bank below.';
              }
            },
            'step@member.home.bank/manage': {
              templateUrl: 'app/views/member/bank/manage/list.html'
            },
            'side@member.home.bank/manage': {
              templateUrl: 'app/views/member/shared/overlay/side-options.html',
              controller: function($scope){
                $scope.title = 'Options';
                $scope.showAddBank = true;
              }
            }
          }
        })


        .state('member.home.bank/detail', {
          url: 'bank/detail/:bankId',
          data: {roles: ['authenticated', 'primary'], overlay: true},
          abstract: true,
          views: {
            'overlay@': {
              templateUrl: 'app/views/member/shared/overlay/layout.html',
              controller: 'getBankCtrl'
            }
          }
        })
        .state('member.home.bank/detail.list', {
          url: '',
          data: {roles: ['authenticated', 'primary'], overlay: true},
          views: {
            'header@member.home.bank/detail': {
              templateUrl: 'app/views/member/shared/overlay/header-default.html',
              controller: function($scope, OVERLAY){
                $scope.title = 'Bank account details';
                $scope.info = 'To remove this bank account, click remove on the right.';
              }
            },
            'step@member.home.bank/detail': {
              templateUrl: 'app/views/member/bank/detail/list.html'
            },
            'side@member.home.bank/detail': {
              templateUrl: 'app/views/member/shared/overlay/side-options.html',
              controller: function($scope){
                $scope.title = 'Options';
                $scope.showManageBank = true;
                $scope.showRemoveBank = true;
                $scope.showRemoveBankOptions = false;
              }
            }
          }
        })


        .state('member.home.bank/add', {
          url: 'bank/add',
          data: {roles: ['authenticated', 'full'], overlay: true},
          abstract: true,
          views: {
            'overlay@': {
              templateUrl: 'app/views/member/shared/overlay/layout.html',
              controller: function($scope, OVERLAY) {
                $scope.overlay = OVERLAY['member.home.bank/add'];
              }
            },
            'side@member.home.bank/add': {
              templateUrl: 'app/views/member/shared/overlay/side-text.html',
              controller: 'addBankSidebarCtrl'
            }
          }
        })
        .state('member.home.bank/add.step1', {
          url: '',
          params: {
            redirect: '',
          },
          data: {roles: ['authenticated', 'full'], overlay: true},
          views: {
            'header@member.home.bank/add': {
              templateUrl: 'app/views/member/shared/overlay/header-default.html',
              controller: function($scope, OVERLAY){
                $scope.title = 'Add bank account';
                $scope.info = 'You can easily load your card by linking your bank account to your card now.  Click "Get Started" below, to begin.';
              }
            },
            'step@member.home.bank/add': {
              templateUrl: 'app/views/member/bank/add/step1.html'
            },
            'footer@member.home.bank/add': {
              templateUrl: 'app/views/member/shared/overlay/footer.html',
              controller: 'selectAccountCtrl'
            }
          }
        })
        .state('member.home.bank/add.success', {
          url: '',
          params: {
            redirect: '',
          },
          data: {roles: ['authenticated', 'full'], overlay: true},
          views: {
            'header@member.home.bank/add': {
              templateUrl: 'app/views/member/shared/overlay/header-default.html',
              controller: function($scope, OVERLAY){
                $scope.title = 'Congratulations!';
                  $scope.info = $scope.info = 'Your bank account has been successfully linked to your ' +
                      $scope.brand.commonProgramName + '.';
              }
            },
            'step@member.home.bank/add': {
              templateUrl: 'app/views/member/bank/add/newBankList.html',
              controller: 'listNewBankCtrl',
              controllerAs: 'listNewBank'
            },
            'side@member.home.bank/add': {
              templateUrl: 'app/views/member/bank/add/side-text.html',
              controller: function ($scope, $state){
                $scope.title = 'Options';
                $scope.info = 'To view all of your linked bank accounts, click Manage Bank Accounts.';
                $scope.printManageBanks = function(){
                  $state.go('member.home.bank/manage.list');
                };
              }
            },
            'footer@member.home.bank/add': {
              templateUrl: 'app/views/member/shared/overlay/footer.html',
              controller: function($scope, $stateParams){
                $scope.cancel = false;
                if($scope.brand === 'uptogether'){
                  $scope.primaryBtn = {
                    title: 'Bank Load',
                    state: 'member.home.bank/transfer.step1'
                  };
                }
                if ($stateParams.redirect) {
                  $scope.primaryBtn = {
                    title: 'Ok',
                    state: $stateParams.redirect,
                  };
                } else {
                  $scope.okBtn = {
                    title: 'Ok',
                  };
                }
              }
            }
          }
        })
        .state('member.home.bank/add.confirmation', {
          url: '',
          data: {roles: ['authenticated', 'full'], overlay: true},
          views: {
            'header@member.home.bank/add': {
              templateUrl: 'app/views/member/shared/overlay/header-default.html',
              controller: function($scope, OVERLAY){
                $scope.title = 'Bank account linked';
                $scope.info = 'Congratulations! Your bank account has been successfully linked to your ' +
                    $scope.brand.commonProgramName + '.';
              }
            },
            'step@member.home.bank/add': {
              templateUrl: 'app/views/member/bank/add/confirmation.html',
              controller: 'confirmationCtrl',
              controllerAs: 'confirmation'
            },
            'footer@member.home.bank/add': {
              templateUrl: 'app/views/member/shared/overlay/footer.html',
              controller: function($scope){
                $scope.btns = [{
                  title: 'LOAD NOW',
                  state: 'member.home.bank/transfer.step1'
                }];
              }
            }
          }
        })
        .state('member.home.bank/add.error', {
          url: '',
          data: {roles: ['authenticated', 'primary'], overlay: true},
          views: {
            'header@member.home.bank/add': {
              templateUrl: 'app/views/member/shared/overlay/header-default.html',
              controller: function($scope){
                $scope.title = 'Sorry, there was a problem';
                $scope.info = 'We were unable to verify your account. Please read below for more information.';
              }
            },
            'step@member.home.bank/add': {
              templateUrl: 'app/views/member/bank/add/error.html',
              controller: function($scope){
                $scope.verifyError = true;
              }
            },
            'side@member.home.bank/add': {
              templateUrl: 'app/views/member/shared/overlay/side-text.html',
              controller: function($scope){
                $scope.title = 'Please Note';
                $scope.info = 'You may only link bank accounts that are in your own name. Linking 3rd party bank accounts may ' +
                    'result in your ' + $scope.brand.commonProgramName + ' being suspended. For cardholders linking business accounts, ' +
                    'please provide proof of bank statement that displays you are a registered agent on the account to bankverification@' + $scope.brand.programUrl;
              }
            },
            'footer@member.home.bank/add': {
              templateUrl: 'app/views/member/shared/overlay/footer.html',
              controller: function($scope){
                $scope.cancel = true;
                $scope.btns = [{
                  title: 'EDIT',
                  state: 'member.home.bank/add.step1'
                }];
              }
            }
          }
        })
        .state('member.home.bank/transfer', {
          url: 'bank/{transferType:load|withdraw}',
          params: {
            transferType: 'load'
          },
          data: {roles: ['authenticated', 'full'], overlay: true},
          abstract: true,
          views: {
            'overlay@': {
              templateUrl: 'app/views/member/shared/overlay/layout.html',
              controller: 'bankTransferCtrl'
            }
          }
        })
        .state('member.home.bank/transfer.step1', {
          url: '',
          data: {roles: ['authenticated', 'full'], overlay: true},
          views: {
            'header@member.home.bank/transfer': {
              templateUrl: 'app/views/member/shared/overlay/header-transfer.html',
              controller: function ($scope, OVERLAY){
                if($scope.transferType == 'load'){
                  $scope.title = 'Bank Load';
                  $scope.info = 'Here you can transfer money from your bank account to your ' +
                      $scope.brand.commonProgramName + '. Simply enter an amount, choose a source and then click next.';
                  $scope.direction = 'To';
                } else {
                  $scope.title = 'Bank Withdraw';
                  $scope.info = 'Here you can transfer money from your ' + $scope.brand.commonProgramName + ' to your bank account. Simply enter an amount, choose a destination and then click next.';
                  $scope.direction = 'From';
                }
              }
            },
            'step@member.home.bank/transfer': {
              templateUrl: 'app/views/member/bank/transfer/step1.html',
              controller: function($scope){
                if($scope.transferType == 'load'){
                  $scope.direction = 'To';
                } else {
                  $scope.direction = 'From';
                }
              }
            },
            'side@member.home.bank/transfer': {
              templateUrl: 'app/views/member/shared/overlay/side-options.html',
              controller: function($scope, Session){
                $scope.showManageBank = true;
                if($scope.transferType == 'load'){
                  $scope.isExpense = Session.getExpense();
                  $scope.title = 'Load Timing';
                  $scope.bankTransferInfo = '<p><strong>Standard Loads</strong> ' +
                    'These loads take 2 full business days to process.  Bank loads scheduled after 7:30 PM CST will start processing the following business day.</p>' +
                    '<p><strong>Instant Loads</strong> These loads post to your account typically within seconds. ' +
                    (Session.getExpense() ? 'To enable instant bank loading, please contact partnersupport@usio.com.' : 'To enable instant loads on a bank account, process a successful standard bank load of $200 or more. After the standard bank load is processed, you may process instant bank loads up to $' + Session.getLimits()['BNK-TRN-IN'].pendingVolume + ' at a time.</p>');
                  $scope.showAutoLoads = true;
                }
              }
            },
            'footer@member.home.bank/transfer': {
              templateUrl: 'app/views/member/shared/overlay/footer.html',
              controller: function($scope){
                $scope.mainBtn = {
                  title: 'NEXT',
                  attemptSubmission: true
                };
                $scope.cancel = true;
              }
            }
          }
        })
        .state('member.home.bank/transfer.step2', {
          url: '',
          data: {roles: ['authenticated', 'full'], overlay: true},
          views: {
            'header@member.home.bank/transfer': {
              templateUrl: 'app/views/member/shared/overlay/header-transfer.html',
              controller: function ($scope, OVERLAY){
                if($scope.transferType == 'load'){
                  $scope.title = 'Ok, let\'s review';
                  $scope.info = 'We\'re almost done. Review everything below and click Load when you\'re ready.';
                  $scope.direction = 'To';
                } else {
                  $scope.title = 'Ok, let\'s review';
                  $scope.info = 'We\'re almost done. Review everything below and click Withdraw when you\'re ready.';
                  $scope.direction = 'From';
                }
              }
            },
            'step@member.home.bank/transfer': {
              templateUrl: 'app/views/member/bank/transfer/step2.html',
              controller: function($scope){
                $scope.sourceLabel = ($scope.transferType == 'load' ? 'Source' : 'Destination');
              }
            },
            'side@member.home.bank/transfer': {
              templateUrl: 'app/views/member/shared/overlay/side-text.html',
              controller: function($scope){
                //$scope.title = 'Availability';
                if($scope.transferType == 'load'){
                  //$scope.info = 'This load is estimated to post to your ' + $scope.brand.commonProgramName + ' on Tuesday, March 10 before 9am.';
                } else {
                  //$scope.info = 'This withdraw is estimated to post to from ' + $scope.brand.commonProgramName + ' on Tuesday, March 10 before 9am.';
                }
              }
            },
            'footer@member.home.bank/transfer': {
              templateUrl: 'app/views/member/shared/overlay/footer.html',
              controller: function($scope){
                var title;
                if ($scope.transferType == 'load') {
                  if ($scope.isExpense) {
                    title = 'I AGREE';
                  } else {
                    title = 'LOAD';
                  }
                } else {
                  title = 'WITHDRAW';
                }

                $scope.mainBtn = {
                  title: title,
                  processForm: true,
                };
                $scope.btns = [{
                  title: 'EDIT',
                  state: 'member.home.bank/transfer.step1'
                }];
                $scope.cancel = true;
              }
            }
          }
        })
        .state('member.home.bank/transfer.confirmation', {
          url: '',
          data: {roles: ['authenticated', 'full'], overlay: true},
          views: {
            'header@member.home.bank/transfer': {
              templateUrl: 'app/views/member/shared/overlay/header-transfer.html',
              controller: function ($scope){
                $scope.title = 'Your Transfer has been scheduled!';
                $scope.direction = ($scope.transferType == 'load' ? 'To' : 'From');
              }
            },
            'step@member.home.bank/transfer': {
              templateUrl: 'app/views/member/bank/transfer/confirmation.html'
            },
            'side@member.home.bank/transfer': {
              templateUrl: 'app/views/member/shared/overlay/side-text.html'
            },
            'footer@member.home.bank/transfer': {
              templateUrl: 'app/views/member/shared/overlay/footer.html',
              controller: function($scope){
                $scope.close = true;
              }
            }
          }
        })

        .state('member.home.bank/transfer/recurring', {
          url: 'bank/{transferType:load|withdraw}/recurring',
          data: {roles: ['authenticated', 'full'], overlay: true},
          abstract: true,
          views: {
            'overlay@': {
              templateUrl: 'app/views/member/shared/overlay/layout.html',
              controller: 'bankTransferRecurringCtrl'
            }
          }
        })
        .state('member.home.bank/transfer/recurring.step1', {
          url: '',
          data: {roles: ['authenticated', 'full'], overlay: true},
          views: {
            'header@member.home.bank/transfer/recurring': {
              templateUrl: 'app/views/member/shared/overlay/header-transfer.html',
              controller: function ($scope, OVERLAY){
                if($scope.transferType == 'load'){
                  $scope.title = 'Auto Bank Load';
                  $scope.info = 'Enter the amount, initial transfer date, and the frequency at which you would like this automatic bank load to occur.';
                  $scope.direction = 'To';
                } else {
                  $scope.title = 'Auto Withdrawal';
                  $scope.info = 'Enter the amount, initial transfer date, and the frequency at which you would like this automatic bank withdraw to occur.';
                  $scope.direction = 'From';
                }
              }
            },
            'step@member.home.bank/transfer/recurring': {
              templateUrl: 'app/views/member/bank/recurring/schedule/step1.html',
              controller: function($scope){
                $scope.sourceLabel = ($scope.transferType == 'load' ? 'Select Source' : 'Select Destination');
              }
            },
            'side@member.home.bank/transfer/recurring': {
              templateUrl: 'app/views/member/shared/overlay/side-options.html',
              controller: function($scope){
                $scope.showManageBank = true;
                $scope.showManageAutoTransfers = true;
              }
            },
            'footer@member.home.bank/transfer/recurring': {
              templateUrl: 'app/views/member/shared/overlay/footer.html',
              controller: function($scope){
                $scope.mainBtn = {
                  title: 'NEXT',
                  attemptSubmission: true
                };
                $scope.cancel = true;
              }
            }
          }
        })
        .state('member.home.bank/transfer/recurring.step2', {
          url: '',
          data: {roles: ['authenticated', 'full'], overlay: true},
          views: {
            'header@member.home.bank/transfer/recurring': {
              templateUrl: 'app/views/member/shared/overlay/header-transfer.html',
              controller: function ($scope, OVERLAY){
                if($scope.transferType == 'load'){
                  $scope.title = 'Ok, let\'s review';
                  $scope.info = 'We\'re almost done. Review everything below and click Save when you\'re ready.';
                  $scope.direction = 'To';
                } else {
                  $scope.title = 'Ok, let\'s review';
                  $scope.info = 'We\'re almost done. Review everything below and click Save when you\'re ready.';
                  $scope.direction = 'From';
                }
              }
            },
            'step@member.home.bank/transfer/recurring': {
              templateUrl: 'app/views/member/bank/recurring/schedule/step2.html',
              controller: function($scope){
                $scope.sourceLabel = ($scope.transferType == 'load' ? 'Source' : 'Destination');
              }
            },
            'side@member.home.bank/transfer/recurring': {
              templateUrl: 'app/views/member/shared/overlay/side-text.html',
              controller: function($scope){
                //$scope.title = 'Availability';
                if($scope.transferType == 'load'){
                  //$scope.info = 'This load is estimated to post to your ' + $scope.brand.commonProgramName + ' on Tuesday, March 10 before 9am.';
                } else {
                  //$scope.info = 'This withdraw is estimated to post to from ' + $scope.brand.commonProgramName + ' on Tuesday, March 10 before 9am.';
                }
              }
            },
            'footer@member.home.bank/transfer/recurring': {
              templateUrl: 'app/views/member/shared/overlay/footer.html',
              controller: function($scope){
                var title;
                if ($scope.transferType == 'load') {
                  if ($scope.isExpense) {
                    title = 'I AGREE';
                  } else {
                    title = 'LOAD';
                  }
                } else {
                  title = 'WITHDRAW';
                }
                $scope.mainBtn = {
                  title: title,
                  processForm: true
                };
                $scope.btns = [{
                  title: 'EDIT',
                  state: 'member.home.bank/transfer/recurring.step1'
                }];
                $scope.cancel = true;
              }
            }
          }
        })
        .state('member.home.bank/transfer/recurring.confirmation', {
          url: '',
          data: {roles: ['authenticated', 'full'], overlay: true},
          views: {
            'header@member.home.bank/transfer/recurring': {
              templateUrl: 'app/views/member/shared/overlay/header-transfer.html',
              controller: function ($scope){
                var startDate = moment($scope.$parent.formData.StartDate).format('dddd, MMMM DD YYYY');
                $scope.title = 'Your auto bank ' + $scope.transferType + ' is set up';
                $scope.info = 'Your bank ' + $scope.transferType + 's will begin on ' + startDate + '.';
                $scope.direction = ($scope.transferType == 'load' ? 'To' : 'From');
              }
            },
            'step@member.home.bank/transfer/recurring': {
              templateUrl: 'app/views/member/bank/recurring/schedule/confirmation.html'
            },
            'side@member.home.bank/transfer/recurring': {
              templateUrl: 'app/views/member/shared/overlay/side-text.html',
              controller: function($scope){
                //$scope.title = 'Estimated Post';
                if($scope.transferType == 'load'){
                  //$scope.info = 'This load is estimated to post to your ' + $scope.brand.commonProgramName + ' on Tuesday, March 10 before 9am.';
                } else {
                  //$scope.info = 'This withdraw is estimated to post to from ' + $scope.brand.commonProgramName + ' on Tuesday, March 10 before 9am.';
                }
              }
            },
            'footer@member.home.bank/transfer/recurring': {
              templateUrl: 'app/views/member/shared/overlay/footer.html',
              controller: function($scope){
                $scope.close = true;
              }
            }
          }
        })

        .state('member.home.bank/recurring/manage', {
          url: 'bank/{transferType:load|withdraw}/recurring/manage',
          data: {roles: ['authenticated', 'full'], overlay: true},
          abstract: true,
          views: {
            'overlay@': {
              templateUrl: 'app/views/member/shared/overlay/layout.html',
              controller: function($scope, $stateParams, OVERLAY){
                var transferType = $stateParams.transferType;
                $scope.transferType = transferType;
                $scope.overlay = (transferType == 'load' ? OVERLAY['member.home.bank/load/recurring/manage'] : OVERLAY['member.home.bank/withdraw/recurring/manage']);
              }
            }
          }
        })
        .state('member.home.bank/recurring/manage.list', {
          url: '',
          data: {roles: ['authenticated', 'full'], overlay: true},
          views: {
            'header@member.home.bank/recurring/manage': {
              templateUrl: 'app/views/member/shared/overlay/header-default.html',
              controller: function($scope, OVERLAY){
                $scope.title = 'Your automatic loads';
                $scope.info = 'Here you can manage your automatic loads. You can remove or modify a load by clicking on one below.';
              }
            },
            'step@member.home.bank/recurring/manage': {
              templateUrl: 'app/views/member/bank/recurring/manage/list.html',
              controller: 'bankRecurringListCtrl'
            },
            'side@member.home.bank/recurring/manage': {
              templateUrl: 'app/views/member/shared/overlay/side-options.html',
              controller: function($scope){
                $scope.showManageBank = true;
                $scope.showAddBank = true;
              }
            }
          }
        })

        .state('member.home.bank/recurring/edit', {
          url: 'bank/{transferType:load|withdraw}/recurring/edit/{recurringId}',
          data: {roles: ['authenticated', 'full'], overlay: true},
          abstract: true,
          views: {
            'overlay@': {
              templateUrl: 'app/views/member/shared/overlay/layout.html',
              controller: 'bankTransferRecurringCtrl'
            }
          }
        })
        .state('member.home.bank/recurring/edit.step1', {
          url: '',
          data: {roles: ['authenticated', 'full'], overlay: true},
          views: {
            'header@member.home.bank/recurring/edit': {
              templateUrl: 'app/views/member/shared/overlay/header-default.html',
              controller: function($scope, OVERLAY){
                if($scope.transferType == 'load'){
                  $scope.title = 'Auto Bank Load';
                } else {
                  $scope.title = 'Auto Bank Withdraw';
                }

                $scope.info = 'Enter the amount, initial transfer date, and the frequency at which you would like this automatic bank load to occur.';
              }
            },
            'step@member.home.bank/recurring/edit': {
              templateUrl: 'app/views/member/bank/recurring/manage/edit.html'
            },
            'side@member.home.bank/recurring/edit': {
              templateUrl: 'app/views/member/shared/overlay/side-options.html',
              controller: function($scope, $state, $http, $stateParams){
                var transferType = $stateParams.transferType;
                var recurringId  = $stateParams.recurringId;
                $scope.showManageAutoTransfers = true;
                $scope.showRemoveTransfer = true;
              }
            },
            'footer@member.home.bank/recurring/edit': {
              templateUrl: 'app/views/member/shared/overlay/footer.html',
              controller: function($scope, $state, $stateParams){
                $scope.mainBtn = {
                  title: 'NEXT',
                  attemptSubmission: true
                };
                $scope.cancel = true;
              }
            }
          }
        })
        .state('member.home.bank/recurring/edit.step2', {
          url: '',
          data: {roles: ['authenticated', 'full'], overlay: true},
          views: {
            'header@member.home.bank/recurring/edit': {
              templateUrl: 'app/views/member/shared/overlay/header-default.html',
              controller: function($scope){
                $scope.title = 'Ok, let\'s review';
                $scope.info = 'We\'re almost done. Review everything below and click Save when you\'re ready';
              }
            },
            'step@member.home.bank/recurring/edit': {
              templateUrl: 'app/views/member/bank/recurring/manage/step2.html'
            },
            'footer@member.home.bank/recurring/edit': {
              templateUrl: 'app/views/member/shared/overlay/footer.html',
              controller: function($scope){
                $scope.mainBtn = {
                  title: 'SAVE',
                  processForm: true,
                };
                $scope.cancel = true;
              }
            }
          }
        })
        .state('member.home.bank/recurring/edit.confirmation', {
          url: '',
          data: {roles: ['authenticated', 'full'], overlay: true},
          views: {
            'header@member.home.bank/recurring/edit': {
              templateUrl: 'app/views/member/shared/overlay/header-transfer.html',
              controller: function ($scope){
                var startDate = moment($scope.$parent.formData.StartDate).format('dddd, MMMM DD YYYY');
                $scope.title = 'Your auto bank ' + $scope.transferType + ' has been updated';
                $scope.info = 'Your bank ' + $scope.transferType + 's will begin on ' + startDate + '.';
                $scope.direction = ($scope.transferType == 'load' ? 'To' : 'From');
              }
            },
            'step@member.home.bank/recurring/edit': {
              templateUrl: 'app/views/member/bank/recurring/schedule/confirmation.html'
            },
            'side@member.home.bank/recurring/edit': {
              templateUrl: 'app/views/member/shared/overlay/side-text.html',
              controller: function($scope){
                //$scope.title = 'Estimated Post';
                if($scope.transferType == 'load'){
                  //$scope.info = 'This load is estimated to post to your ' + $scope.brand.commonProgramName + ' on Tuesday, March 10 before 9am.';
                } else {
                  //$scope.info = 'This withdraw is estimated to post to from ' + $scope.brand.commonProgramName + ' on Tuesday, March 10 before 9am.';
                }
              }
            },
            'footer@member.home.bank/recurring/edit': {
              templateUrl: 'app/views/member/shared/overlay/footer.html',
              controller: function($scope){
                $scope.close = true;
              }
            }
          }
        });

    // Public routes
    $stateProvider
        .state('root.login', {
          url: '/login',
          data: {roles: ['public', 'full'], overlay: false, noBkgHeader: true},
          params: {
            username: ""
          },
          views: {
            '@':{
              templateUrl: 'app/views/login/login.html',
              controller: 'loginCtrl'
            }
          }
        })

        .state('root.sso', {
          url: '/sso/:token',
          data: {roles: ['public', 'full'], overlay: false, noBkgHeader: true},
          views: {
            '@':{
              templateUrl: 'app/views/login/sso.html',
              controller: 'ssoRedirectCtrl'
            }
          }
        })

        .state('redirectCardBalance', {
          url: '/cardBalance',
          // Use onEnter to redirect to the cardBalance state with a default brandName
          onEnter: ['$state', function($state) {
            // Redirect to the cardBalance state with a default brandName
            $state.go('cardBalance', { brandName: 'akimbo' });
          }]
        })
        .state('cardBalance', {
          url: '/:brandName/cardBalance',
          data: {roles: ['public', 'full'], overlay: false},
          views: {
            '@':{
              templateUrl: 'app/views/card-balance/card-balance.html',
              controller: 'cardBalanceCtrl'
            }
          }
        })
        .state('cardBalance.viewCardBalance', {
          url: '/balance',
          data: {roles: ['public', 'full'], overlay: false},
          views: {
            '@': {
              templateUrl: 'app/views/card-balance/view-card-balance.html',
              controller: function($scope, Session){
                $scope.liteCardBalance = Session.getLiteBalance();
                $scope.liteBrand = Session.getLiteBrand();
              }
            }
          }
        })

        .state('root.fraud', {
          url: '/alert',
          params: {
            username: null,
            previousState: null
          },
          data: {roles: ['public', 'full'], overlay: false, noBkgHeader: true},
          views: {
            '@': {
              templateUrl: 'app/views/login/loginFraud.html',
              controller: 'fraudCtrl',
              controllerAs: 'fraud'
            }
          }
        })
        .state('logout', {
          url: '/logout',
          data: {roles: ['public', 'full'], overlay: false},
          controller: 'logoutCtrl'
        })

        .state('verifyEmail', {
          url: '/verify/:data',
          data: {roles: ['public', 'full'], overlay: false, noBkgHeader: true},
          views: {
            'top-header': {
              templateUrl: 'app/views/index/top-header.html'
            },
            '@': {
              templateUrl: 'app/views/join/email-verify.html',
              controller: 'verifyEmailCtrl'
            },
            'footer': {
              templateUrl: 'app/views/member/shared/footer.html'
            }
          }
        })

        .state('root.mobileid', {
          url: '/mobileid',
          data: {roles: ['public', 'full'], overlay: false, noBkgHeader: true},
          params: {
          },
          abstract: true,
          views: {
            'top-header': {
              templateUrl: 'app/views/index/top-header.html'
            },
            '@': {
              templateUrl: 'app/views/join/layout.html',
              controller: function($scope){
                $scope.alertError = {};
                $scope.parent = {};
                $scope.parent.formType = 'floatingForm-form';
                $scope.parent.overlayLoading = false;
                $scope.formData = {};
                $scope.joinTitle = 'Collect Card';
                $scope.showFooterAsterisks = true;
              }
            }
          }
        })
        .state('root.mobileid.verify', {
          url: '/verify',
          data: {roles: ['public', 'full'], overlay: false, noBkgHeader: true},
          params: {
          },
          views: {
            'header@root.mobileid': {
              template: function(){
                return '<h2>Verify and collect your card.</h2><p>To collect your refund, please go through the Idemia Mobile ID process to verify your identity. Once verification is complete, return here and complete registration.</p>';
              }
            },
            'step@root.mobileid': {
              templateUrl: 'app/views/mobile-id/mobile-id.html',
              controller: 'mobileIdCtrl'
            }
          }
        })
        .state('root.mobileid.success', {
          url: '/success?code&state',
          data: {roles: ['public', 'full'], overlay: false, noBkgHeader: true},
          views: {
            'header@root.mobileid': {
              template: function(){
                return '<h2>Verify and collect your card.</h2><p>To collect your refund, please go through the Idemia Mobile ID process to verify your identity. Once verification is complete, return here and complete registration.</p>';
              }
            },
            'step@root.mobileid': {
              templateUrl: 'app/views/mobile-id/mobile-id-success.html',
              controller: 'mobileIdSuccessCtrl'
            }
          }
        })
        .state('root.mobileid.collect', {
          url: '/collect',
          data: {roles: ['public', 'full'], overlay: false, noBkgHeader: true},
          views: {
            'header@root.mobileid': {
              template: function(){
                return '<h2>Verify and collect your card.</h2><p>To collect your refund, please go through the Idemia Mobile ID process to verify your identity. Once verification is complete, return here and complete registration.</p>';
              }
            },
            'step@root.mobileid': {
              templateUrl: 'app/views/mobile-id/mobile-id-collect.html',
              controller: 'mobileIdCollectCtrl'
            }
          }
        })

        .state('root.resetpassword', {
          url: '/resetpassword',
          abstract: true,
          data: {roles: ['public', 'full'], overlay: false, noBkgHeader: true},
          views: {
            'top-header': {
              templateUrl: 'app/views/index/top-header.html'
            },
            '@': {
              templateUrl: 'app/views/resetpassword/layout.html',
              controller: function($scope){
                $scope.formData = {};
                $scope.range = function (min, max, reverse){
                  var options = [];
                  for(var i = min; i <= max; i++){
                    options.push(i);
                  }
                  return (reverse ? options.reverse() : options);
                };
              }
            },
            'footer': {
              templateUrl: 'app/views/member/shared/footer.html'
            }
          }
        })
        .state('root.resetpassword.step1', {
          url: '',
          data: {roles: ['public', 'full'], overlay: false},
          views: {
            'step@root.resetpassword': {
              templateUrl: 'app/views/resetpassword/reset-step1.html',
              controller: 'resetpasswordCtrl'
            }
          }
        })
        .state('root.resetpassword.step2', {
          url: '',
          data: {roles: ['public', 'full'], overlay: false},
          views: {
            'step@root.resetpassword': {
              templateUrl: 'app/views/resetpassword/reset-step2.html',
              controller: 'resetpasswordCtrl'
            }
          }
        })
        .state('root.resetpassword.success', {
          url: '',
          data: {roles: ['public', 'full'], overlay: false},
          views: {
            'step@root.resetpassword': {
              templateUrl : 'app/views/resetpassword/success.html'
            }
          }
        })
        .state('root.resetpassword.mobilesuccess', {
          url: '',
          data: {roles: ['public', 'full'], overlay: false},
          views: {
            'step@root.resetpassword': {
              templateUrl : 'app/views/resetpassword/mobile-success.html'
            }
          }
        })
        .state('root.resetpassword.error', {
          url: '',
          data: {roles: ['public', 'full'], overlay: false},
          views: {
            'step@root.resetpassword': {
              templateUrl : 'app/views/resetpassword/error.html'
            }
          }
        })
        .state('root.resetpassword.corporate', {
          url: '/corporate',
          data: {roles: ['public', 'full'], overlay: false},
          views: {
            'step@root.resetpassword': {
              templateUrl: 'app/views/resetpassword/corporate.html',
            }
          }
        })

        .state('root.privacy', {
          url: '/privacy-policy',
          data: {roles: ['public', 'full'], overlay: false, noBkgHeader: true},
          views: {
            '@':{
              templateUrl: 'app/views/legal/privacy-policy.html'
            }
          }
        })
        .state('root.contact', {
          url: '/contact',
          data: {roles: ['public', 'full'], overlay: false, noBkgHeader: true},
          views: {
            '@':{
              templateUrl: 'app/views/contact/contact.html',
              controller: function ($scope, $state){
                $scope.phoneNumber = $scope.brand.programContactPhone;
                var splitPhone = $scope.phoneNumber.split(' ');
                if (splitPhone.length > 1) {
                  $scope.phoneNumber = splitPhone[1].replace('(', '').replace(')', '');
                }
              },
            }
          }
        })
        .state('root.fees', {
          url: '/fees',
          data: {roles: ['public', 'full'], overlay: false, noBkgHeader: true},
          views: {
            '@':{
              templateUrl: 'app/views/fees/fees.html',
              controller: 'feesCtrl',
              controllerAs: 'fees'
            }
          }
        })
        .state('root.giftCollection', {
          url: '/card-collection?email&amount&sender',
          data: {roles: ['public', 'full'], overlay: false, noBkgHeader: true},
          views: {
            '@':{
              templateUrl: 'app/views/gift-collection/gift-collection.html',
              controller: 'giftCollectionCtrl',
              controllerAs: 'giftCollection'
            }
          }
        })

        // create gift card routes
        .state('root.giftCard', {
          url: '/giftcard',
          data: {
            roles: ['public', 'full'],
            overlay: false,
            headerSecondaryLinks: true
          },
          abstract: true,
          views: {
            'top-header': {
              templateUrl: 'app/views/index/top-header.html'
            },
            '@': {
              templateUrl: 'app/views/giftCard/layout.html',
              controller: 'giftCardCtrl'
            }
          }
        })
        .state('root.giftCard.step1', {
          url: '',
          data: {roles: ['public', 'full'], overlay: false},
          views: {
            'header@root.giftCard': {
              template: function(){
                return '<h2 class="gift-header">Let\'s create a gift card.</h2><p>You\'re just moments away ' +
                  'from creating a <span ng-bind-html="brand.fullGiftProgramName"></span>.</p>';
              }
            },
            'step@root.giftCard': {
              templateUrl: 'app/views/giftCard/step1.html'
            }
          }
        })
        .state('root.giftCard.step2', {
          url: '',
          data: {roles: ['public', 'full'], overlay: false},
          views: {
            'header@root.giftCard': {
              template: function(){
                return '<h2 class="gift-header">Where would you like to send this gift card?</h2><p>Please ' +
                    'select where you would like us to send this {{formData.amount | akimboCurrency}} {{brand.commonGiftProgramName}}.</p>';
              }
            },
            'step@root.giftCard': {
              templateUrl: 'app/views/giftCard/step2.html'
            }
          }
        })
        .state('root.giftCard.step3', {
          url: '',
          data: {roles: ['public', 'full'], overlay: false},
          views: {
            'header@root.giftCard': {
              template: function(){
                return '<h2 class="gift-header">Let\'s review and pay for your gift card.</h2><p>When you\'re ready to purchase your gift card, please click on "Place Order" below.</p>';
              }
            },
            'step@root.giftCard': {
              templateUrl: 'app/views/giftCard/step3.html'
            }
          }
        })
        .state('root.giftCard.success', {
          url: '',
          data: {roles: ['public', 'full'], overlay: false},
          params: {
            showVideo: false,
          },
          views: {
            'header@giftCard': {
              template: function(){
                return '<h2 class="gift-header">Success!</h2><p>You\'ve successfully ordered a <span ng-bind-html="brand.fullGiftProgramName"></span>. You will receive an email receipt shortly.</p>';
              }
            },
            'step@root.giftCard': {
              templateUrl: 'app/views/giftCard/success.html',
              controller: function ($scope, $window, $stateParams, $state, $location){
                if ($stateParams.showVideo) {
                  $scope.showVideo = true;
                  var video = document.querySelector("#video");
                  video.play();
                }
              }
            }
          }
        })


        // activate routes
        .state('root.activate', {
          url: '/activate',
          data: {
            roles: ['public', 'full'],
            overlay: false,
            noBkgHeader: true,
            headerSecondaryLinks: true
          },
          abstract: true,
          views: {
            'top-header': {
              templateUrl: 'app/views/index/top-header.html'
            },
            '@': {
              templateUrl: 'app/views/join/layout.html',
              controller: function ($scope, $window, $stateParams, $state, $location){
                $scope.joinType = $stateParams.joinType;
                $scope.formData = {};
                $scope.alertError = {};
                $scope.parent = {};
                $scope.alertError.show = false;
                $scope.alertError.message = '';
                $scope.joinTitle = 'Activate Your ' + $scope.brand.commonProgramName;

                // Set form type for layout
                $scope.parent.formType = 'floatingForm-form';

                $scope.showAlert = function (title){
                  $window.alert(title);
                };
                $scope.range = function (min, max, reverse){
                  var options = [];
                  for(var i = min; i <= max; i++){
                    options.push(i);
                  }
                  return (reverse ? options.reverse() : options);
                };
              }
            }
          }
        })
        .state('root.activate.step1', {
          url: '',
          data: {roles: ['public', 'full'], overlay: false},
          views: {
            'header@root.activate': {
              template: function(){
                return '<h2>Activation</h2><p>Already activated your card? <a ui-sref="root.login">Log in now</a>.</p>';
              }
            },
            'step@root.activate': {
              templateUrl: 'app/views/activate/activate-step1.html',
              controller: 'cardActivateCtrl'
            }
          }
        })
        .state('root.activate.successLogin', {
          url: '',
          data: {
            roles: ['public', 'full'],
            overlay: false,
            noBkgHeader: true,
            headerSecondaryLinks: true
          },
          views: {
            'top-header': {
              templateUrl: 'app/views/index/top-header.html'
            },
            '@': {
              templateUrl: 'app/views/activate/activate-success.html',
              controller: function($scope, $stateParams){
                $scope.activateLogin = true;
                $scope.activateSubTitle = 'Login to view your card balance and transactions.';
                $scope.activateInfo = '';
              }
            }
          }
        })
        .state('root.activate.successRegister', {
          url: '',
          data: {
            roles: ['public', 'full'],
            overlay: false,
            noBkgHeader: true,
            headerSecondaryLinks: true
          },
          views: {
            'top-header': {
              templateUrl: 'app/views/index/top-header.html'
            },
            '@': {
              templateUrl: 'app/views/activate/activate-success.html',
              controller: function($scope, $stateParams){
                $scope.activateRegister = true;
                $scope.activateSubTitle = 'Now that your card is activated, we highly recommend you register your card by clicking the button below.';
                $scope.activateInfo = 'Registering your ' + $scope.brand.commonProgramName + ' will allow you to set your address so you can make online purchases with your card. You\'ll also set up a password so you can view your card balance and transactions online.';
              }
            }
          }
        })


        // Collect gift routes
        .state('root.collect', {
          url: '/collect',
          data: {
            roles: ['public', 'full'],
            overlay: false,
            headerSecondaryLinks: false
          },
          abstract: true,
          views: {
            'top-header': {
              templateUrl: 'app/views/index/top-header.html'
            },
            '@': {
              templateUrl: 'app/views/join/layout.html',
              controller: function($scope){
                $scope.alertError = {};
                $scope.parent = {};
                $scope.parent.formType = 'floatingForm-form';
                $scope.parent.overlayLoading = false;
                $scope.formData = {};
                $scope.joinTitle = 'Collect Card';
                $scope.showFooterAsterisks = true;

                $scope.range = function (min, max, reverse){
                  var options = [];
                  for(var i = min; i <= max; i++){
                    options.push(i);
                  }
                  return (reverse ? options.reverse() : options);
                };
              }
            }
          }
        })
        .state('root.collect.virtual', {
          url: '/virtual/:email',
          metaTags: {
            keywords: function() {
              var absUrl = window.location.href;
              return 'app-id=505199985, app-argument=' + absUrl;
            }
          },
          data: {
            roles: ['public', 'full'],
            overlay: false,
            noBkgHeader: true
          },
          views: {
            'header@root.collect': {
              template: function(){
                return '<h2>Collect your card and create your account.</h2><p>Don\'t worry, this is the only page you\'ll need to fill out. You will create a password during this process so you can log in and view your virtual card information, along with your card balance and transactions.</p>';
              }
            },
            'step@root.collect': {
              templateUrl: 'app/views/collect/virtual-step1.html',
              controller: 'giftVirtualRegister'
            }
          }
        })
        .state('root.collect.virtual.esignDisclosure', {
          url: '',
          data: {roles: ['public', 'full'], overlay: false},
          views: {
            'header@root.collect': {
              template: function(){
                return '<h2>Read the Documents Below</h2><p>Read the full documents then click agree if you agree. If you do not agree please contact support.</p>';
              }
            },
            'step@root.collect': {
              templateUrl: 'app/views/collect/esign-disclosure.html',
              controller: 'giftVirtualRegister',
              controllerAs: 'esign'
            }
          }
        })
        .state('root.collect.register', {
          url: '/register',
          data: {
            roles: ['public', 'full'],
            overlay: false,
            noBkgHeader: true
          },
          views: {
            'header@root.collect': {
              template: function(){
                return '<h2>Card-in-Hand Registration.</h2><p>This is the only page you\'ll fill out. After this, you\'ll be able to log in and view your virtual card information.  Have you already registered your virtual card? <a ui-sref="root.login">Log in now</a>.</p>';
              }
            },
            'step@root.collect': {
              templateUrl: 'app/views/collect/register-step1.html',
              controller: 'giftRegister'
            }
          }
        })
        .state('root.collect.registerStep2', {
          url: '/register',
          data: {
            roles: ['public', 'full'],
            overlay: false,
            noBkgHeader: true
          },
          views: {
            'header@root.collect': {
              template: function(){
                return '<h2>KYC</h2><p>This is the only page you\'ll fill out. After this, you\'ll be able to log in and view your virtual card information.  Have you already registered your virtual card? <a ui-sref="root.login">Log in now</a>.</p>';
              }
            },
            'step@root.collect': {
              templateUrl: 'app/views/collect/register-step2.html',
              controller: 'giftRegister'
            }
          }
        })
        .state('root.collect.plastic', {
          url: '/plastic/:email',
          data: {
            roles: ['public', 'full'],
            overlay: false,
            noBkgHeader: true
          },
          views: {
            'header@root.collect': {
              template: function(){
                return '<h2>Tell us where to send your card.</h2><p>Don\'t worry, this is the only page you\'ll need to fill out. You will create a password during this process so you can log in and view your balance and transactions.</p>';
              }
            },
            'step@root.collect': {
              templateUrl: 'app/views/collect/plastic-step1.html',
              controller: 'giftPlastic'
            }
          }
        })
        .state('root.collect.esign-disclosure', {
          url: '',
          data: {roles: ['public', 'full'], overlay: false},
          views: {
            'header@root.join': {
              template: function() {
                return '<h2>Read the Documents Below</h2><p>Read the full documents then click agree if you agree. If you do not agree please contact support.</p>';
              }
            },
            'step@root.join': {
              templateUrl: 'app/views/join/esign-disclosure.html',
              controller: 'esignDisclosureCtrl',
              controllerAs: 'esign'
            }
          }
        })

        // Consumer choice  routes
        .state('root.choice', {
          url: '/consumer-choice?email&amount&sender&phone&redeemCode',
          data: {
            roles: ['public', 'full'],
            overlay: false,
            headerSecondaryLinks: false
          },
          abstract: true,
          views: {
            '@': {
              templateUrl: 'app/views/consumer-choice/layout.html',
              controller: function($scope, $stateParams){
                $scope.alertError = {};
                $scope.parent = {};
                $scope.parent.formType = 'floatingForm-form';
                $scope.parent.overlayLoading = false;
                $scope.formData = {};
                $scope.joinTitle = 'Collect Funds';
                $scope.showFooterAsterisks = true;
              }
            }
          }
        })
        .state('root.choice.step1', {
          url: '',
          data: {
            roles: ['public', 'full'],
            overlay: false,
            noBkgHeader: true
          },
          views: {
            'header@root.choice': {
              template: function(){
                return '<p>You\'re one step closer to collecting your money. Choose below if you would like to view your virtual Mastercard<sup>&reg;</sup>, withdraw to your bank account, or receive a paper check.</p>';
              }
            },
            'step@root.choice': {
              templateUrl: 'app/views/consumer-choice/step1.html',
              controller: 'consumerChoiceCtrl',
            }
          }
        })
        .state('root.choice.step2', {
          url: '',
          data: {
            roles: ['public', 'full'],
            overlay: false,
            noBkgHeader: true
          },
          params: {
            redirect: null,
          },
          views: {
            'header@root.choice': {
              template: function(){
                return '<h2>Create your account and collect your funds.</h2><p>You will create a password during this process so you can log in and view your virtual card number or continue with an alternative disbursement method.  If you choose to receive your funds as a virtual card, you will also be able to view your transaction history and card balance.</p>';
              }
            },
            'step@root.choice': {
              templateUrl: 'app/views/consumer-choice/step2.html',
              controller: 'consumerChoiceCreateCtrl',
            }
          }
        })

        // Same as root.collect
        .state('root.redeem', {
          url: '/redeem',
          data: {
            roles: ['public', 'full'],
            overlay: false,
            headerSecondaryLinks: false
          },
          abstract: true,
          views: {
            'top-header': {
              templateUrl: 'app/views/index/top-header.html'
            },
            '@': {
              templateUrl: 'app/views/join/layout.html',
              controller: function($scope){
                $scope.alertError = {};
                $scope.parent = {};
                $scope.parent.formType = 'floatingForm-form';
                $scope.parent.overlayLoading = false;
                $scope.formData = {};
                $scope.joinTitle = 'Redeem Card';
                $scope.showFooterAsterisks = true;

                $scope.range = function (min, max, reverse){
                  var options = [];
                  for(var i = min; i <= max; i++){
                    options.push(i);
                  }
                  return (reverse ? options.reverse() : options);
                };
              }
            }
          }
        })
        .state('root.redeem.virtual', {
          url: '/virtual/:RedeemCode?fname&lname&email&phone&deliveryMethod',
          metaTags: {
            keywords: function() {
              var absUrl = window.location.href;
              return 'app-id=505199985, app-argument=' + absUrl;
            }
          },
          params: {
            redirect: null,
          },
          data: {
            roles: ['public', 'full'],
            overlay: false,
            noBkgHeader: true
          },
          views: {
            'header@root.redeem': {
              template: function(){
                return '<h2>Redeem your card</h2><p>You will create a password during this process so you can log in and view your virtual card information, along with your card balance and transactions.</p>';
              }
            },
            'step@root.redeem': {
              templateUrl: 'app/views/collect/redeem-virtual-step1.html',
              controller: 'redeemVirtualCtrl'
            }
          }
        })
        .state('root.redeem.virtual.esignDisclosure', {
          url: '',
          data: {roles: ['public', 'full'], overlay: false},
          views: {
            'header@root.redeem': {
              template: function() {
                return '<h2>Read the Documents Below</h2><p>Read the full documents then click agree if you agree. If you do not agree please contact support.</p>';
              }
            },
            'step@root.redeem': {
              templateUrl: 'app/views/collect/esign-disclosure-redeem.html',
              controller: 'redeemVirtualCtrl',
              controllerAs: 'esign'
            }
          }
        })
        .state('root.redeem.virtual2', {
          url: '/virtual',
          metaTags: {
            keywords: function() {
              var absUrl = window.location.href;
              return 'app-id=505199985, app-argument=' + absUrl;
            }
          },
          data: {
            roles: ['public', 'full'],
            overlay: false,
            noBkgHeader: true
          },
          views: {
            'header@root.redeem': {
              template: function(){
                return '<h2>Redeem your card</h2><p>You will create a password during this process so you can log in and view your virtual card information, along with your card balance and transactions.</p>';
              }
            },
            'step@root.redeem': {
              templateUrl: 'app/views/collect/redeem-virtual-step1.html',
              controller: 'redeemVirtualCtrl'
            }
          }
        })
        .state('root.redeem.success', {
          url: '/success',
          data: {roles: ['public', 'full'], overlay: false},
          params: {
            successMessage:  "",
            username: "",
          },
          views: {
            'header@root.redeem': {
              template: function(){
                return '<h2>Congratulations!</h2><p>Your card has now been added to your existing account. Login below.</p>';
              }
            },
            'step@root.redeem': {
              templateUrl: 'app/views/collect/redeem-success.html',
              controller: 'successRedeemCtrl'
            }
          }
        })

        .state('root.register', {
          url: '/register?v',
          data: {
            roles: ['public', 'full'], overlay: false,
            noBkgHeader: true
          },
          abstract: true,
          views: {
            'top-header': {
              templateUrl: 'app/views/index/top-header.html'
            },
            '@': {
              templateUrl: 'app/views/join/layout.html',
              controller: function ($scope, $window, $stateParams, $state, $location){
                $scope.joinType = $stateParams.joinType;
                $scope.formData = {};
                $scope.alertError = {};
                $scope.parent = {};
                $scope.alertError.show = false;
                $scope.alertError.message = '';
                $scope.joinTitle = 'Register Your ' + $scope.brand.commonProgramName;
                $scope.showFooterAsterisks = true;

                // initialize parent scope for email and username validation
                $scope.validation = {};
                $scope.validation.validEmail = false;
                $scope.validation.uniqueEmail = false;
                $scope.validation.emailBlurred = false;

                $scope.validation.usernameBlurred = false;
                $scope.validation.validUsername = false;
                $scope.validation.uniqueUsername = false;

                $scope.validation.requiresKyc = false;

                // Set form type for layout
                $scope.parent.formType = 'floatingForm-form';

                $scope.showAlert = function (title){
                  $window.alert(title);
                };
                $scope.range = function (min, max, reverse){
                  var options = [];
                  for(var i = min; i <= max; i++){
                    options.push(i);
                  }
                  return (reverse ? options.reverse() : options);
                };
              }
            },
            'footer': {
              templateUrl: 'app/views/member/shared/footer.html'
            }
          }
        })
        .state('root.register.step1', {
          url: '',
          data: {roles: ['public', 'full'], overlay: false},
          views: {
            'header@root.register': {
              template: function(){
                return '<h2>Registration</h2><p>Registering your card will allow you to set your address so you can make online purchases with your card. You\'ll also set up a password so you can view your card balance and transactions online.</p>';
              }
            },
            'step@root.register': {
              templateUrl: 'app/views/register/register-step1.html',
              controller: 'cardRegisterCtrl'
            }
          }
        })
        .state('root.register.esignDisclosure', {
          url: '',
          data: {roles: ['public', 'full'], overlay: false},
          views: {
            'header@root.register': {
              template: function(){
                return '<h2>Read the Documents Below</h2><p>Read the full documents then click agree if you agree. If you do not agree please contact support.</p>';
              }
            },
            'step@root.register': {
              templateUrl: 'app/views/register/esign-disclosure.html',
              controller: 'esignDisclosureCtrl',
              controllerAs: 'esign'
            }
          }
        })
        .state('root.register.step2', {
          url: '',
          data: {roles: ['public', 'full'], overlay: false},
          views: {
            'header@root.register': {
              template: function(){
                return '<h2>Registration</h2><p>Registering your card will allow you to set your address so you can make online purchases with your card. You\'ll also set up a password so you can view your card balance and transactions online.</p>';
              }
            },
            'step@root.register': {
              templateUrl: 'app/views/register/register-step2.html',
              controller: 'cardRegisterCtrl'
            }
          }
        })
        .state('root.register.step3', {
          url: '',
          data: {roles: ['public', 'full'], overlay: false},
          views: {
            'header@root.register': {
              template: function(){
                return '<h2>Registration</h2><p>Set a card PIN and your account password below.  You\'ll use your email address and password to access your account online.</p>';
              }
            },
            'step@root.register': {
              templateUrl: 'app/views/register/register-step3.html',
              controller: 'cardRegisterCtrl'
            }
          }
        })
        .state('root.register.step4', {
          url: '',
          data: {roles: ['public', 'full'], overlay: false},
          views: {
            'header@root.register': {
              template: function(){
                return '<h2>Registration</h2><p>Please fill out the required information below.</p>';
              }
            },
            'step@root.register': {
              templateUrl: 'app/views/register/register-step4.html',
              controller: 'cardRegisterCtrl'
            }
          }
        })
        .state('root.register.success', {
          url: '/success',
          data: {roles: ['public', 'full'], overlay: false},
          params: {
            successMessage:  "",
            credentials: {
            },
          },
          views: {
            'header@root.register': {
              template: function(){
                return '<h2>Almost There!</h2><p>Your card has now been registered, please proceed to the dashboard by clicking the button below.</p>';
              }
            },
            'step@root.register': {
              templateUrl: 'app/views/register/register-success.html',
              controller: 'successRegisterCtrl'
            }
          }
        })

        .state('signup', {
          url: '/signup',
          data: {roles: ['public', 'full'], overlay: false, noBkgHeader: true},
          abstract: true,
          views: {
            'top-header': {
              templateUrl: 'app/views/index/top-header.html'
            },
            '@': {
              templateUrl: 'app/views/signup/layout.html',
              controller: 'signupCtrl',
              controllerAs: 'signup'
            },
            'footer': {
              templateUrl: 'app/views/member/shared/footer.html'
            }
          }
        })
        .state('signup.create', {
          url: '/create?CardName"',
          data: {roles: ['public', 'full'], overlay: false},
          views: {
            'step@signup': {
              templateUrl: 'app/views/signup/create.html',
              controller: 'signupCreateCtrl',
              controllerAs: 'create'
            },
            'signup-progress@signup.create': {
              templateUrl: 'app/views/signup/signup-progress.html',
              controller: 'signupProgressCtrl',
              controllerAs: 'progress'
            }
          }
        })
        .state('signup.customize', {
          url: '/customize',
          data: {roles: ['public', 'full'], overlay: false},
          views: {
            'step@signup': {
              templateUrl: 'app/views/signup/customize.html',
              controller: 'signupCustomizeCtrl',
              controllerAs: 'customize'
            },
            'signup-progress@signup.customize': {
              templateUrl: 'app/views/signup/signup-progress.html',
              controller: 'signupProgressCtrl',
              controllerAs: 'progress'
            }
          }
        })
        .state('signup.signin', {
          url: '/signin',
          data: {roles: ['public', 'full'], overlay: false},
          views: {
            'step@signup': {
              templateUrl: 'app/views/signup/signin.html',
              controller: 'signupSigninCtrl',
              controllerAs: 'signin'
            },
            'signup-progress@signup.signin': {
              templateUrl: 'app/views/signup/signup-progress.html',
              controller: 'signupProgressCtrl',
              controllerAs: 'progress'
            }
          }
        })
        .state('signup.feeSchedule', {
          url: '/fee-schedule',
          data: {roles: ['public', 'full'], overlay: false},
          views: {
            'step@signup': {
              templateUrl: 'app/views/signup/fee-schedule.html',
              controller: 'signupEnrollmentFeeScheduleCtrl',
              controllerAs: 'feeSchedule'
            }
          }
        })
        .state('signup.order', {
          url: '/order',
          data: {roles: ['public', 'full'], overlay: false},
          views: {
            'step@signup': {
              templateUrl: 'app/views/signup/order.html',
              controller: 'signupOrderCtrl',
              controllerAs: 'order'
            },
            'signup-progress@signup.order': {
              templateUrl: 'app/views/signup/signup-progress.html',
              controller: 'signupProgressCtrl',
              controllerAs: 'progress'
            }
          }
        })
        .state('signup.confirmation', {
          url: '/confirmation',
          data: {roles: ['public', 'full'], overlay: false},
          views: {
            'step@signup': {
              templateUrl: 'app/views/signup/confirmation.html',
              controller: 'signupConfirmationCtrl',
              controllerAs: 'confirmation'
            }
          }
        })

        /*
   * Join Routes
   * @param joinType dictates flow of join either
   *   enrollment or register
   */
        .state('root.join', {
          url: '/{joinType:enrollment}?redeem&email&ma',
          data: {roles: ['public', 'full'], overlay: false, noBkgHeader: true},
          abstract: true,
          views: {
            'top-header': {
              templateUrl: 'app/views/index/top-header.html'
            },
            '@': {
              templateUrl: 'app/views/join/layout.html',
              controller: function ($scope, $window, $stateParams, $state, $location, Session){
                $scope.joinType = $stateParams.joinType;
                $scope.formData = {};
                $scope.formData.CardDesignId = 115;
                $scope.alertError = {};
                $scope.parent = {};
                $scope.alertError.show = false;
                $scope.alertError.message = '';
                $scope.joinTitle = 'Join Now';
                $scope.showFooterAsterisks = true;

                // initialize parent scope for email and username validation
                $scope.validation = {};
                $scope.validation.validEmail = false;
                $scope.validation.verifiedEmail = false;
                $scope.validation.uniqueEmail = false;
                $scope.validation.emailBlurred = false;

                $scope.validation.usernameBlurred = false;
                $scope.validation.validUsername = false;
                $scope.validation.uniqueUsername = false;

                // Set form type for layout
                $scope.parent.formType = 'en-form';

                $scope.showAlert = function (title){
                  $window.alert(title);
                };
                $scope.range = function (min, max, reverse){
                  var options = [];
                  for(var i = min; i <= max; i++){
                    options.push(i);
                  }
                  return (reverse ? options.reverse() : options);
                };
              }
            }
          }
        })
        .state('root.join.step1', {
          url: '',
          data: {roles: ['public', 'full'], overlay: false},
          views: {
            'header@root.join': {
              template: function($scope){
                if(($scope.brand === 'akimbo' || $scope.brand === 'officecard') && !$scope.redeem){
                  return '<h2>Joining is now by invitation only.</h2><p>In order to enroll for a card, you must have an Invitation Code.</p>';
                }
                else if($scope.joinType === 'register'){
                  return '<h2>Registration is easy.</h2><p>Activate your account in minutes.</p>';
                } else {
                  return '<h2>Joining is easy!</h2><p>It only takes a couple of minutes to sign up and order your new card.</p>';
                }
              }
            },
            'step@root.join': {
              templateUrl: 'app/views/join/getting-started.html',
              controller: 'step-1-joinCtrl'
            }
          }
        })
        .state('root.join.esign-disclosure', {
          url: '',
          data: {roles: ['public', 'full'], overlay: false},
          views: {
            'header@root.join': {
              template: function() {
                return '<h2>Read the Documents Below</h2><p>Read the full documents then click agree if you agree. If you do not agree please contact support.</p>';
              }
            },
            'step@root.join': {
              templateUrl: 'app/views/join/esign-disclosure.html',
              controller: 'esignDisclosureCtrl',
              controllerAs: 'esign'
            }
          }
        })
        .state('root.join.feeSchedule', {
          url: '',
          data: {roles: ['public', 'full'], overlay: false},
          views: {
            'header@root.join': {
              template: function() {
                return '<h2 id="feeScheduleTxt">Here are the fees for this card.</h2>';
              }
            },
            'step@root.join': {
              templateUrl: 'app/views/join/fee-schedule.html',
              controller: 'signupEnrollmentFeeScheduleCtrl',
              controllerAs: 'feeSchedule'
            }
          }
        })
        .state('root.join.step2', {
          url: '',
          data: {roles: ['public', 'full'], overlay: false},
          views: {
            'header@root.join': {
              template: function($stateParams){
                if($stateParams.joinType === 'register'){
                  return '<h2>Contact Information</h2><p>To make sure you\'re not a robot.</p>';
                } else {
                  return '<h2>Contact Information</h2><p>Please tell us where to send your new <b><span ng-bind-html="brand.fullProgramName"></span></b>.</p>';
                }
              }
            },
            'step@root.join': {
              templateUrl: 'app/views/join/contact-info.html',
              controller: 'step-2-3-joinCtrl'
            }
          }
        })
        .state('root.join.step3', {
          url: '',
          data: {roles: ['public', 'full'], overlay: false},
          views: {
            'header@root.join': {
              template: '<h2>Demographics</h2><p>Last page... I promise.</p>'
            },
            'step@root.join': {
              templateUrl: 'app/views/join/cdd-info.html',
              controller: 'step-2-3-joinCtrl'
            }
          }
        })
        .state('root.join.success', {
          url: '/success',
          data: {roles: ['public', 'full'], overlay: false},
          params: {
            successMessage:  "",
            credentials: {
            },
          },
          views: {
            'header@root.join': {
              template: function(){
                return '<h2>Almost There!</h2><p>Your card has now been registered, please proceed to the dashboard by clicking the button below.</p>';
              }
            },
            'step@root.join': {
              templateUrl: 'app/views/join/success.html',
              controller: 'success-joinCtrl',
            }
          }
        })
        .state('root.join.welcome', {
          url: '',
          data: {roles: ['public', 'full'], overlay: false},
          views: {
            'header@root.join': {
              template: function($scope){
                if($scope.joinType === 'register'){

                  return '<h2>Welcome to the {{brand.programName}} community!</h2><p>Your <span ng-bind-html="brand.fullProgramName"></span> has been registered and is ready to use. Log in below now.</p>';

                } else {
                  return '<h2>Welcome to the {{brand.programName}} community!</h2><p>You\'ve successfully enrolled for your <span ng-bind-html="brand.fullProgramName"></span>. Your new card should arrive by mail in the next 5-7 business days. But, you don\'t have to wait to access some of your card\'s great features. Log in below now.</p>';
                }
              }
            },
            'step@root.join': {
              templateUrl: 'app/views/join/welcome.html',
              controller: 'step-2-3-joinCtrl'
            }
          }
        })
        .state('root.join.mobilewelcome', {
          url: '',
          data: {roles: ['public', 'full'], overlay: false},
          views: {
            'header@root.join': {
              template: function($scope){
                if($scope.joinType === 'register'){
                  return '<h2>Welcome to the {{brand.programName}} community!</h2><p>Your <span ng-bind-html="brand.fullProgramName"></span> has been registered and is ready to use. Log in below now.</p>';
                } else {
                  return '<h2>Welcome to the {{brand.programName}} community!</h2><p>You\'ve successfully enrolled for your <span ng-bind-html="brand.fullProgramName"></span>. Your new card should arrive by mail in the next 5-7 business days. But, you don\'t have to wait to access some of your card\'s great features. Log in below now.</p>';
                }
              }
            },
            'step@root.join': {
              templateUrl: 'app/views/join/mobile-welcome.html',
              controller: 'step-2-3-joinCtrl'
            }
          }
        });

    // TODO: put logic in place where if a user is logged in
    // direct them to /member/home
    $urlRouterProvider.otherwise(function ($injector, $location){
      var path = $location.path();
      var Session = $injector.get('Session');

      switch(path){
          // check if username is missing from path for legacy urls
        case '/member/profile':
        case '/member/directdeposit':
        case '/member/send/transfer':
        case '/member/profile/smsmanage':
        case '/member/bank/load':
        case '/member/bank/add':
        case '/member/profile/activate':
        case '/member/subaccount/add':
          // add default username 'home'
          path = path.replace('/member/', '/member/home/');
          return path;
        default:
          //reference brand from cookie for login route
          var brand = Session.getBrand() ? Session.getBrand() : 'akimbo';
          return brand+'/login';
      }

    });

  }]);

// Rollbar error tracking service
akimboApp.config(['RollbarProvider', 'ENV', 'ROLLBAR_OFF', function(RollbarProvider, ENV, ROLLBAR_OFF) {
    if (ROLLBAR_OFF) {
        return;
    }

    RollbarProvider.init({
      accessToken: "55229e4816e248078809753e6af68341",
      captureUncaught: true,
      payload: {
        environment: ENV,
        client: {
          javascript: {
            code_version: '20240819'
          }
        }
      },
      autoInstrument: {
        dom: false,
      },
      scrubFields: [
        'CardNumber',
        'CVV',
        'number',
        'cvv'
      ],
      ignoredMessages: [
        "Script error"
      ]
    });
}]);

/*
 * Run Block to Monitor All Route Changes
 * Redirects unauthenticated users to /login
 *
 */
akimboApp.run(['$window', '$state', '$rootScope', '$injector', '$location', '$idle', 'cacheService', 'authService', 'memberService', 'Session', 'LogoutService', 'brandService',
  function ($window, $state, $rootScope, $injector, $location, $idle, cacheService, authService, memberService, Session, LogoutService, brandService) {
    // Start watching for idle users
    $idle.watch();

    // Check if there is a user after a refresh
    if(Session.getUser()){
      $rootScope.user = Session.getUser();
    }

    // Listen for window resize event
    $window.onresize = function(){
      if($window.innerWidth < 768){
        $rootScope.isMobileView = true;
      } else {
        $rootScope.isMobileView = false;
      }
    };

    $rootScope.isMobileView = ($window.innerWidth < 768) ? true : false;
    $rootScope.displayWidgets = false;

    // Overlay for loading, in footer template
    $rootScope.overlayLoading = false;

    // Cache the last unauthenticated state and params
    $rootScope.lastUnAuthenticatedToState = null;
    $rootScope.lastUnAuthenticatedToParams = null;

    // Access Control
    $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
      var sliceIndex  = toState.name.lastIndexOf('.');
      var parentState = toState.name.slice(0, sliceIndex);

      // Check if user is not logged in or expired cookie
      if(toState.data.roles[0] == 'authenticated' && !authService.isAuthenticated()) {
        event.preventDefault();
        $rootScope.lastUnAuthenticatedToState = toState.name;
        $rootScope.lastUnAuthenticatedToParams = toParams;
        //if the user cannot be authenticated and they are not going through Jumio then log them out.
        if(Session.getEnrollmentErrorCode() !== 150){
          LogoutService.destroy();
        }
        else{
          $state.go('member.home');
        }
        // Check if getUsername is undefined
      } else if (toState.data.roles[0] == 'authenticated' && typeof Session.getUsername() == 'undefined'){

        clearSessionAndLogin();
        // Check if getUser is undefined
      } else if (toState.data.roles[0] == 'authenticated' && typeof Session.getUser() == 'undefined'){

        clearSessionAndLogin();
        // Check CH has access to state
      } else if (toState.data.roles[1] == 'primary' && !$rootScope.hasMainAccess){

        event.preventDefault();
        $state.go('member.home');
        // Check if user is restricted from the next state
      } else if(toState.data.roles[0] == 'authenticated' && Session.getUser().isRestricted) {

        var user = Session.getUser();
        var restrictedStates = user.restrictedStates;
        var restrictions = user.restrictions;

        var displayRestriction = function(state){
          //event.preventDefault();
          // Get the parent state by trimming the child state identifier
          // looking for (.step1, .list, .new)
          var stepView    = 'step@' + parentState;
          var footerView  = 'footer@' + parentState;
          var sideView    = 'side@' + parentState;
          var message     = memberService.getRestrictionMessage(state);

          // Create template for the restricted view
          toState.views[stepView].template = '<ul class="form"><li class="form-with-content-small"><div class="content"><p>' + message + '</p></div></li></ul>';

          if(toState.views[footerView])
            toState.views[footerView].templateUrl = '';

          if(toState.views[sideView])
            toState.views[sideView].templateUrl = '';
        };

        // check if toState is a restriction
        for(var r in restrictedStates){
          if(toState.name == restrictedStates[r]){
            // All loads and withdraws have toParams
            // check if there is a toParam
            // check if toParams matchs with restriction type

            if(toParams.transferType){
              if(restrictions.transferType == 'both'){
                displayRestriction(toState.name);
              } else if(toParams.transferType == restrictions.transferType){
                displayRestriction(toState.name);
              }
            } else {
              displayRestriction(toState.name);
            }
            break;
          }
        }
      } else if(parentState == 'root.giftCard') {
        var brand = Session.getBrand();
        var brandData = brandService.getBrand(brand);

        if (brandData.giftCardOrderingDisabled) {
          event.preventDefault();
          $state.go('root.login', {brand: brand});
        }
      }

      function clearSessionAndLogin() {
        event.preventDefault();
        LogoutService.destroy();
      }

      // Check if next state is an overlay
      if(toState.data.overlay){
        angular.element(document.body).addClass('overlay-active');
      } else {
        angular.element(document.body).removeClass('overlay-active');
      }

      if(toState.name == 'printFeed'){
        angular.element(document.body).addClass('print-view-active');
      } else {
        angular.element(document.body).removeClass('print-view-active');
      }

      if(parentState == 'giftCard'){
        angular.element(document.body).addClass('giftcard-bkg');
      } else {
        angular.element(document.body).removeClass('giftcard-bkg');
      }

    });

    $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams){
      // Default the previous tab to home (if user refreshes, breaks rootscope)
      $rootScope.previousTab = $rootScope.previousTab || 'member.home';
      $rootScope.previousParams = fromParams;
      var pageUrl = window.location.href;

      gtag('event', 'navigate', {
        'event_category': 'Web App State',
        'to_state': toState.name,
        'from_state': fromState.name,
        'page_url': pageUrl,
      });

      // On navigation, set if user is on home page
      $rootScope.isHomePage = toState.name.includes('member.home') && !toState.name.includes('member.home.expanded');

      // only check for cases that are highlevel states
      switch(fromState.name){
        case 'member.home':
        case 'member.network':
        case 'member.load':
        case 'member.withdraw':
        case 'member.subaccount':
          $rootScope.previousTab = fromState.name;
          break;
      }

      // Check if we lost the username params, required for the subaccount.transactions state
      if($rootScope.previousTab == 'member.subaccount.transactions' && !$rootScope.previousParams.Username){
        $rootScope.previousTab = 'member.subaccount';
      }


      // Back function used in overlay closeBtn and X
      $rootScope.back = function(){
        // When coming from our Android app, let's send a custom schema that will allow the app
        // to close the webview.  Otherwise, return to the previous state.
        fullUrl = $window.location.href;
        if(fullUrl.indexOf('deviceType=android') > -1) {
          $window.location.href = 'akimboCard://exit';
        } else {
          $state.go($rootScope.previousTab, $rootScope.previousParams, {reload: true});
        }

      };

    });
  }], ['$rootScope', 'MetaTags', runBlock]);

function runBlock($rootScope, MetaTags) {
  $rootScope.MetaTags = MetaTags;
}
